{
  "staff_lookup_help": "Enter a complete email or mobile (+30 or +357) to check for an existing account. No name or partial searches.",
  "staff_lookup_loading": "Checking account...",
  "staff_lookup_error": "Account check failed. Change the contact and try again.",
  "staff_lookup_conflict": "These details do not identify one account. Check the contacts or contact support.",
  "staff_lookup_not_found": "No existing account matches these contacts. Create a new staff account below.",
  "staff_lookup_existing": "Existing account",
  "staff_lookup_change": "Change account",
  "staff_lookup_select": "Use this account",
  "staff_lookup_assign": "Add access",
  "STAFF_ACCOUNT_EXISTS": "An account now exists with these details. Search again and select it.",
  "empty_staff_title": "There is no staff yet",
  "empty_staff_description": "Add your academy's coaches and admins and set which teams they can access. They will log in with the email you enter and see their teams in the app.",
  "empty_files_title": "There are no files yet",
  "empty_files_period_title": "There are no files in this date range",
  "empty_announcements_period_title": "There are no announcements in this date range",
  "empty_period_description": "Try changing the date range to see existing entries.",
  "empty_files_description": "Send documents, instructions or anything members need to one or more teams or to specific players. Files appear in the files section inside the app.",
  "empty_files_filtered_title": "No files match these filters",
  "empty_files_filtered_description": "Try changing or clearing the filters and search.",
  "empty_forms_title": "There are no forms yet",
  "empty_forms_description": "Create a form to collect information from parents and players, or an evaluation for the coach to fill in. Once you assign it to players, you can track who has completed it.",
  "empty_products_title": "There are no products yet",
  "empty_products_description": "Create a product, such as a subscription or clothing, then charge it to the players concerned, as a single payment or in installments. Parents see the payment in the app and you track the academy's revenue.",
  "empty_products_filtered_title": "No products match these filters",
  "empty_club_title": "Start by creating your first team",
  "empty_club_description": "Teams are the foundation of your academy. Once you create one, you get a code to share with parents and players so they can join from the app.",
  "teams_load_failed": "Teams could not be loaded. Please try again.",
  "empty_calendar_title": "There are no activities on this day",
  "activities_load_failed": "Activities could not be loaded. Please try again.",
  "empty_calendar_description": "Create a game, a practice or an event and team members will be notified right away. If a practice happens every week, turn on Repeat so you don't have to enter it again.",
  "empty_players_title": "There are no players yet",
  "empty_players_description": "Players and parents join on their own with the team code from the app. You can also create a player's profile yourself.",
  "empty_announcements_title": "There are no announcements yet",
  "empty_announcements_description": "Send an announcement to one or more teams, or to the whole academy, and you'll see how many members have seen it. A welcome announcement is a good start.",
  "empty_players_filtered_title": "No players found",
  "empty_players_filtered_description": "Try changing or clearing the filters and search.",
  "empty_calendar_filtered_title": "No activities match these filters",
  "empty_announcements_filtered_title": "No announcements match these filters",
  "empty_filtered_description": "Try changing or removing the filters.",
  "empty_clear_filters": "Clear filters",
  "page_help_need_help": "Need help?",
  "page_help_settings_title": "Page help",
  "page_help_settings_description": "Choose which Help Center collection each Manager section opens. Save changes here; maintain the instructions in Intercom.",
  "page_help_language_note": "A help link appears only when this section is enabled and a link exists for the user's language. To use Greek instructions for English users, enter the same Greek link in both fields.",
  "page_help_enabled": "Show help",
  "page_help_greek_url": "Greek collection link",
  "page_help_english_url": "English collection link",
  "page_help_preview": "Preview",
  "page_help_url_hint": "Published collection on help.playerdex.app or intercom.help/playerdex. Leave blank to hide help for this language.",
  "page_help_invalid_url": "Enter an HTTPS PlayerDex Help Center collection link, without a port, query or fragment.",
  "page_help_url_required": "Add at least one collection link before enabling help.",
  "page_help_reload": "Reload latest",
  "page_help_reload_note": "Reload latest replaces your unsaved changes with the currently saved links.",
  "page_help_loading": "Loading help links",
  "page_help_saving": "Saving help links",
  "page_help_saved": "Help links saved. The new links appear on the next page visit or refresh.",
  "page_help_load_error": "Could not load help links. Try Reload latest.",
  "page_help_save_error": "Could not save help links. Your changes remain here; try again.",
  "page_help_conflict": "Another administrator saved changes. Your draft is preserved. Copy any edits you want to keep, then reload the latest links before saving again.",
  "page_help_forbidden": "Only super admins can manage page help. End impersonation before opening these settings.",
  "help_section_announcements": "Announcements",
  "help_section_schedule": "Schedule",
  "help_section_teams": "Teams",
  "help_section_players": "Players",
  "help_section_staff": "Staff",
  "help_section_invitations": "Invitations",
  "help_section_files": "Files",
  "help_section_forms": "Forms",
  "help_section_member_subscriptions": "Member subscriptions / products",
  "help_section_member_payments": "Member payments / revenue",
  "help_section_club_billing": "Academy subscription / billing",
  "help_section_account_settings": "Account settings",
  "billing_details_managed_in_stripe": "Your invoice details are managed in Stripe. Open Billing to continue.",
  "mobile_sign_in_title": "Continue in the PlayerDex app",
  "mobile_sign_in_description": "This sign-in link is for the PlayerDex mobile app. Continue on the phone where you requested it.",
  "mobile_sign_in_open": "Open PlayerDex",
  "mobile_sign_in_open_help": "If the app does not open, return to your email on the same phone and try again. You can also open PlayerDex and request a new sign-in link.",
  "mobile_sign_in_desktop": "Open this email on the phone where you requested the sign-in link.",
  "mobile_sign_in_invalid": "This link is incomplete. Open PlayerDex and request a new sign-in link.",
  "mobile_sign_in_install_help": "Need the app? Install or update PlayerDex, then request a new sign-in link from the app.",
  "mobile_sign_in_manager_help": "To use PlayerDex Manager in your browser, continue to its login page and sign in with an email code.",
  "mobile_sign_in_manager": "Go to Manager login",
  "form_date_range_invalid": "The end date must be the same as or later than the start date.",
  "order_invalid_month": "Enter a valid month in MM/YYYY format or choose it from the calendar.",
  "order_month_out_of_range": "Choose a month between 01/2020 and 01/2099.",
  "order_end_month_before_start": "The ending month must be the same as or later than the starting month.",
  "order_invalid_payment_amounts": "Payment amounts must be non-negative and cannot exceed the order total.",
  "order_unable_to_load_club_teams": "Unable to load academy teams.",
  "impersonation_missing_id": "The selected account has no user ID.",
  "impersonation_identity_mismatch": "The returned account does not match the selected user. Impersonation was cancelled.",
  "impersonation_no_matches": "No matching users found.",
  "impersonation_no_club": "The selected account does not manage an academy.",
  "impersonation_choose_account": "Multiple accounts match. Select the intended account using its ID and academy/team relationships.",
  "impersonation_select_account": "Select account",
  "staff_edit": "Edit staff member",
  "staff_choose_role": "This person has different roles across teams. Choose the role to apply to the selected teams.",
  "staff_edit_failed": "Staff changes could not be saved. Please try again.",
  "staff_updated": "Staff member updated successfully.",
  "email_change_send_code": "Send code",
  "email_change_verify_title": "Verify your email",
  "email_change_verify_save": "Verify and save",
  "email_change_edit_address": "Edit address",
  "email_change_code_notice": "We will send a six-digit code to your new email. Your email will only be saved after you enter the code here.",
  "email_change_code_failed": "We could not send the code. Please try again.",
  "email_change_same_address": "This email is already verified on your account.",
  "registration_language": "Language",
  "registration_brand_title": "Your academy, connected.",
  "registration_brand_description": "Bring your teams, members and daily academy work together in PlayerDex Manager.",
  "registration_brand_details": "Manage schedules, attendance, member information and academy forms from one place.",
  "registration_welcome": "Welcome to PlayerDex",
  "registration_email_description": "Enter your email to sign in or set up your academy.",
  "registration_check_email": "Check your email",
  "registration_link_instructions": "Open the sign-in link we sent to:",
  "registration_email_help": "Use the link in this browser. Check your spam folder if it has not arrived. If the link no longer works, request another.",
  "registration_resend": "Resend link",
  "registration_change_email": "Change email",
  "registration_continue": "Continue",
  "registration_or": "or",
  "registration_email_send_failed": "The email could not be sent. Check your connection and email address, then try again.",
  "registration_phone_description": "Use the phone number already registered to your PlayerDex account.",
  "registration_sms_send_failed": "We could not send the SMS. Check your number and connection, then try again.",
  "registration_sms_code_failed": "The SMS code could not be verified. Check the code or return to email sign-in.",
  "registration_send_sms": "Send SMS",
  "registration_verify_sms": "Verify and sign in",
  "registration_mobile_app": "Coaches, players and parents can also use the PlayerDex mobile app.",
  "registration_session_error": "Your identity could not be synchronized with PlayerDex. Check your connection and retry, or change account.",
  "registration_manager_access_required": "PlayerDex Manager is available only to academy administrators and super administrators. Sign in with an administrator account.",
  "registration_retry": "Try again",
  "registration_change_account": "Sign out / change account",
  "email_code_sent_to": "We sent a 6-digit code to",
  "email_code_expiry_help": "The code is valid for 15 minutes.",
  "email_code_label": "6-digit email verification code",
  "email_code_verify": "Verify",
  "email_code_not_received": "Didn't receive the code?",
  "email_code_resend_in": "Resend in",
  "email_code_resend": "Resend code",
  "email_code_invalid": "That code is incorrect. Check the email and try again.",
  "email_code_expired": "This code has expired or has already been used. Request a new code.",
  "email_code_attempts_exhausted": "Too many incorrect attempts. Request a new code to continue.",
  "email_code_rate_limited": "Please wait before requesting or checking another code.",
  "email_code_unavailable": "We couldn't complete email verification. Please try again.",
  "registration_create_club": "Create your academy",
  "registration_create_profile": "Create your profile",
  "registration_complete_setup": "Complete setup",
  "registration_upload_photo": "Upload Photo",
  "registration_upload_photo_action": "Upload or replace profile photo",
  "registration_photo_preview": "Your profile photo",
  "registration_photo_hint": "Optional. JPEG, PNG or WebP, up to 5 MiB.",
  "registration_undo_photo": "Undo photo selection",
  "registration_club_step_description": "Start with your academy’s essentials. You can add more details later.",
  "registration_admin_step_description": "Add your administrator details to finish setting up your academy.",
  "registration_country_greece": "Greece",
  "registration_color": "Color",
  "registration_country_cyprus": "Cyprus",
  "registration_back": "Back to academy details",
  "registration_sign_out": "Sign out",
  "registration_setup_description": "Add your administrator details and the essentials for your academy. You can add more details in settings later.",
  "registration_verified_email": "Verified email",
  "registration_first_name": "First name",
  "registration_last_name": "Last name",
  "registration_club_name": "Academy name",
  "registration_logo_optional": "Academy logo (optional)",
  "registration_logo_preview": "Academy logo preview",
  "registration_upload_logo": "Upload Logo",
  "registration_upload_logo_action": "Upload or replace academy logo",
  "registration_remove_logo": "Remove logo",
  "registration_logo_hint": "PNG, JPEG or WebP, up to 5 MB. You can add a logo later.",
  "registration_hex_color": "Color (#RRGGBB)",
  "registration_agree": "I accept the",
  "registration_terms": "Terms of Service",
  "registration_and": "and the",
  "registration_privacy": "Privacy Policy",
  "registration_required_name": "Enter a name of 1–100 characters.",
  "registration_choose_country": "Select a country.",
  "registration_choose_sport": "Select a sport.",
  "registration_invalid_color": "Choose an academy color.",
  "registration_accept_terms": "Accept the Terms of Service and Privacy Policy to continue.",
  "registration_invalid_logo": "Choose a PNG, JPEG or WebP image, up to 5 MB.",
  "registration_check_fields": "Check the highlighted fields.",
  "registration_club_created": "Your academy has been created. Finish saving its branding below.",
  "registration_finish_setup": "Finish setup",
  "registration_check_again": "Check academy creation again",
  "registration_creation_uncertain": "We could not confirm whether your academy was created. Check again before continuing. If this persists, contact PlayerDex support; a second academy will not be created from this request.",
  "registration_club_unavailable": "This academy is no longer available to your account. Change account or contact PlayerDex support.",
  "registration_reselect_logo": "Your academy is saved. Choose the logo file again to finish the upload, or remove the logo to continue without it.",
  "registration_logo_retry": "The logo upload did not complete. Your academy is saved. Retry the upload or remove the logo.",
  "registration_logo_remove_failed": "The logo could not be removed. Retry removal before continuing.",
  "registration_save_failed": "Some details could not be saved. Check your connection and retry. Any academy already created will be reused.",
  "registration_access_changed": "An academy is already linked to this account. Refresh the page to continue to your existing academy.",
  "registration_busy": "Setup is already running in another tab. Wait for it to finish, then refresh this page.",
  "registration_verified_email_required": "Sign in with a verified email address to create your academy.",
  "session_identity_changed": "Your account changed. Sign in again before continuing.",
  "error": "Error",
  "errors": "Errors",
  "info": "Info",
  "warning": "Warning",
  "success": "Success",
  "an_error_occurred": "An error occurred!",
  "error_server_not_responding": "Server not responding",
  "login_success": "Login successful",
  "error_during_login": "Error during login. Please try again.",
  "error_during_logout": "Failed to log out. Please try again.",
  "too_many_attempts_try_later": "Too many attempts to login. The user is locked. Please try again later.",
  "menu": "Menu",
  "sidebar_toggle": "Show or hide menu",
  "table_columns": "Columns",
  "show_more": "Show more",
  "brand_color": "Brand color",
  "black": "black",
  "red": "red",
  "orange": "orange",
  "yellow": "yellow",
  "green": "green",
  "light_blue": "light blue",
  "blue": "blue",
  "purple": "purple",
  "change_language": "Change language",
  "switch_to_english": "Switch to English",
  "switch_to_greek": "Switch to Greek",
  "impersonate_user": "Impersonate user?",
  "leave_impersonate": "Leave impersonate",
  "checkout_success_message1": "We appreciate your business! A confirmation email will be sent to",
  "checkout_success_message2": ". If you have any questions, please email: ",
  "choose_plan": "Choose the plan that will make a difference for your academy",
  "start_now": "Start now!",
  "loading": "Loading...",
  "not_a_customer_yet": "Not a customer yet?",
  "welcome_to": "Welcome to",
  "choose_club_modal_title": "Manage another academy?",
  "choose_club_confirmation_msg1": "You have chosen to manage academy with name ",
  "choose_club_confirmation_msg2": "Are you sure?",
  "home": "Announcements",
  "home_subtitle": "Send announcements to your academy's teams, notify members right away and see who has seen them.",
  "schedule_title": "Schedule",
  "schedule_subtitle": "Create and manage the games, practices and events of your academy's teams.",
  "seen_by_parent": "Seen by parent",
  "seen": "Seen",
  "not_seen": "Not seen",
  "no_post_viewers": "No one has seen this post yet.",
  "reacted": "Reacted / Seen",
  "not_reacted": "Not reacted / seen",
  "Leagues": "Leagues",
  "Academies": "Academies",
  "Attendance": "Attendance",
  "Matches": "Matches",
  "Players": "Players",
  "Users": "Users",
  "Payments": "Payments",
  "no_posts_found": "No posts found.",
  "newPost": "New Post",
  "teams": "Teams",
  "type": "Type",
  "types": "Types",
  "viewAll": "View All",
  "ok": "OK",
  "or": "or",
  "text_filter": "Text",
  "training_filter": "Training",
  "match_filter": "Match",
  "createAnnouncement": "Create an announcement",
  "addTraining": "Add a training",
  "addMatch": "Add a match",
  "continue": "Continue",
  "new": "New",
  "post": "Post",
  "attachments": "Attachments",
  "add_attachment": "Add attachment",
  "remove_attachment": "Remove attachment",
  "activity_attachment_empty": "Attachments must not be empty.",
  "activity_attachment_too_large": "Each attachment must be 15 MB or smaller.",
  "activity_attachment_upload_failed": "The attachment could not be uploaded. Please try again.",
  "attach_shared_files": "Attach shared files",
  "attach": "Attach",
  "detach_file": "Detach file",
  "files_attached_successfully": "The files have been attached successfully.",
  "please_select_files_to_attach": "Please select files to attach.",
  "missing_file_url_or_name": "Missing file URL or name",
  "versus": "VS",
  "update": "Update",
  "announcement": "Announcement",
  "uploadPhoto": "Upload Photo",
  "upload_logo": "Upload Logo",
  "save": "Save",
  "delete": "Delete",
  "do_you_want_delete_post": "Are you sure you want to delete this post?",
  "match": "Match",
  "handlePlayers": "Handle players",
  "clubs": "Academies",
  "team": "Team",
  "opponent": "Opponent",
  "opponentClub": "Opponent Club",
  "opponentTeam": "Opponent Team",
  "competition": "Competition",
  "club_admins": "Academy Administrators",
  "venue": "Venue",
  "date": "Date",
  "startTime": "Start Time",
  "endTime": "End Time",
  "location": "Location",
  "stadium": "stadium",
  "homeMatch": "Home Match",
  "training": "Training",
  "repeat": "Repeat",
  "everyWeek": "Every week",
  "payment": "Payment",
  "next": "Next",
  "dueDate": "Due Date",
  "amount": "Amount",
  "paymentPeriod": "Payment period",
  "monthlyPayments": "Monthly payments",
  "installment": "Installment",
  "startingMonth": "Starting Month",
  "endingMonth": "Ending Month",
  "allPlayers": "All Players",
  "assigned": "Assigned",
  "searchPlayer": "Search Player",
  "search_user": "Search User",
  "filter": "Filter",
  "filter_by_player_name": "Filter by player name",
  "unassignAll": "Unassign All",
  "assignAll": "Assign All",
  "createPayment": "Create Payment",
  "price": "Price",
  "installmentsOf": "installments of",
  "installments": "Installments",
  "includeInitialPayment": "Include initial payment",
  "initialPayment": "Initial Payment",
  "noOfPayments": "# of payments",
  "subscription": "Subscription",
  "switch_to": "Switch to",
  "current_plan": "Current Plan",
  "renewal_date": "Renewal Date",
  "subscriptions": "Subscriptions",
  "active": "Active",
  "incomplete": "Incomplete",
  "incomplete_expired": "Incomplete Expired",
  "past_due": "Past Due",
  "paused": "Paused",
  "trialing": "Trialing",
  "unpaid": "Unpaid",
  "active_subscriptions": "Active Subscriptions",
  "no_subscriptions_found": "No subscriptions found!",
  "active_seats": "Active seats",
  "buy_more_seats": "Buy more seats",
  "downgrade_seats": "Downgrade seats",
  "change_plan": "Change plan",
  "renew_plan": "Renew plan",
  "cancel_subscription": "Cancel subscription",
  "invoice_details": "Invoice details",
  "card_details": "Card details",
  "teamware": "Teamware",
  "tournament": "Tournament",
  "tours": "Tours",
  "event": "Event",
  "other": "Other",
  "oneOff": "One-off",
  "oneOffDescription": "One-off payments charge the full amount when the product is purchased.",
  "instalments": "Instalments",
  "instalmentsDescription": "Payments can be set up to be charged every week or month for a number of instalments.",
  "monthly": "Monthly",
  "monthlyDescription": "Subscriptions can be set up to be taken every week or month continuously.",
  "paymentSuccessfullyPaid": "Payment successfully paid",
  "paymentSuccessfullyEdited": "Payment successfully edited",
  "status": "Status",
  "pending": "Pending",
  "completed": "Completed",
  "abbreviation": "Abbreviation",
  "name": "Name",
  "payment_table_header": "PAYMENT",
  "total_table_header": "TOTAL",
  "dueDate_table_header": "DUE DATE",
  "paidOn_table_header": "PAID ON",
  "edit": "Edit",
  "member": "Member",
  "of_player": "Player",
  "player": "Player",
  "deletePlayer": "Are you sure you want to delete this player?",
  "registered": "Registered",
  "pendingInvitation": "Pending invitation",
  "rejected": "rejected",
  "managedByParent": "Managed by parent",
  "mobile": "Mobile",
  "playerUpdatedSuccessfully": "Player updated successfully",
  "playerCreatedSuccessfully": "Player created successfully",
  "back": "Back",
  "firstName": "First Name",
  "lastName": "Last Name",
  "yearOfBirth": "Year of birth",
  "position": "Position",
  "jerseyNumber": "Jersey Number",
  "leagueUpdatedSuccessfully": "League updated successfully",
  "leagueCreatedSuccessfully": "League created successfully",
  "country": "Country",
  "totalAcademies": "Total Academies",
  "activatedAcademies": "Activated Academies",
  "matchReports": "Match Reports",
  "actions": "Action",
  "searchLeagues": "search Leagues",
  "league": "League",
  "searchClubs": "Search Academies",
  "academyCreatedSuccessfully": "Academy created successfully",
  "academyUpdatedSuccessfully": "Academy updated successfully",
  "members": "Members",
  "staff": "Staff",
  "add_staff": "Add staff",
  "parents": "My Parents",
  "my_teams": "My Teams",
  "documents": "Documents",
  "uploaded_at": "Uploaded at",
  "activation": "Activation",
  "selectCountry": "Select Country",
  "selectPlan": "Select Plan",
  "selectTeam": "Select Team",
  "searchAcademies": "Search Academies",
  "academy": "Academy",
  "competitions": "Competitions",
  "logo": "Logo",
  "cover": "Cover",
  "email": "Email",
  "email_or_mobile": "Email or mobile",
  "error_invalid_phone_number": "Invalid phone number",
  "error_invalid_email": "Invalid email address",
  "error_invalid_date": "Invalid date",
  "error_invalid_time": "Invalid time",
  "error_uploading_image": "Error uploading image",
  "activeAcademy": "Active Academy",
  "participant": "Participant",
  "cancel": "Cancel",
  "training_calendar": "TRAINING",
  "eventSuccessfullyUpdated": "Event successfully updated",
  "updateCurrentOnly": "Do you want to update only current Training?",
  "current": "Current",
  "all": "All",
  "title": "Title",
  "participants": "Participants",
  "writeSomething": "Write something...",
  "eventType": "Event Type",
  "phoneNumber": "Phone Number",
  "teamUpdatedSuccessfully": "Team updated successfully",
  "teamCreatedSuccessfully": "Team created successfully",
  "coaches": "Coaches",
  "coachCreatedSuccessfully": "Coach created successfully",
  "coachUpdatedSuccessfully": "Coach updated successfully",
  "coach": "Coach",
  "managerControls": "Manager controls",
  "ageGroup": "Age Group",
  "settings": "Settings",
  "logout": "Logout",
  "amountDescriptionStep1Oneoff": "Fill the price of the payment",
  "amountDescriptionStep1Instalment": "Fill the total price and then set the number of instalments",
  "amountDescriptionStep1Monthly": "Set the monthly price",
  "dateDescriptionStep2Oneoff": "When the payment must take place?",
  "dateDescriptionStep2Instalment": "When the instalment must take place?",
  "dateDescriptionStep2Monthly": "Set the start and end month of the payment",
  "playersDescription": "Select the academy players that should submit the payment",
  "totalPrice": "Total price",
  "monthlyPrice": "Monthly price",
  "selectAll": "Select All",
  "upcoming": "Upcoming",
  "completed_calendar_filter": "Completed",
  "goalkeeper": "Goalkeeper",
  "defender": "Defender",
  "midfielder": "Midfielder",
  "attacker": "Attacker",
  "location_title": "Location",
  "match_title": "Match",
  "training_title": "Training",
  "change": "Edit",
  "doYouWant": "Do you want to",
  "currentOrAll": "only current event or all the associated events?",
  "cancel_verb": "cancel",
  "delete_verb": "delete",
  "general": "General",
  "players": "Players",
  "all_calendar_match": "All",
  "completed_calendar_match": "Completed",
  "pending_calendar_match": "Pending",
  "new_single": "New",
  "match_single": "Match",
  "coach_single": "Coach",
  "player_single": "Player",
  "attended": "Attended",
  "invited": "INVITED",
  "totalPercentage": "TOTAL%",
  "verify": "Verify",
  "activity": "Activity",
  "attendance": "Attendance",
  "training_type": "Training type",
  "create_activity": "New Activity",
  "create_match": "Create Match",
  "create_training": "Create Training",
  "create_event": "Create Event",
  "the_match": "The match",
  "the_event": "The event",
  "the_training": "The training",
  "deleted_successfully": "deleted successfully",
  "from": "from",
  "for": "for",
  "referenceTo": "Reference to",
  "the_weekly_training": "The Weekly Training",
  "has_been": "has been",
  "has": "has",
  "activity_cancelled": "cancelled",
  "are": "are",
  "have_been": "have_been",
  "success_cancellation": "successfully cancelled",
  "type_trainings": "Trainings",
  "activity_table_time": "Time",
  "activity_table_date": "Date",
  "activity_table_team": "Team",
  "activity_table_activity": "Activity",
  "activity_table_location": "Location",
  "activity_table_participants": "Participants",
  "create_match_title": "Opponent",
  "create_activity_team": "Team",
  "notes": "Notes",
  "no_teams_found": "No teams found.",
  "create_activity_location": "Location",
  "create_activity_title": "Title",
  "create_activity_teams": "Teams",
  "create_activity_date": "Starts",
  "create_activity_from_time": "From",
  "create_activity_to_time": "Duration",
  "create_training_end_date": "Ends",
  "create_training_schedule": "Repeat",
  "create_activity_arrival": "Arrival time",
  "create_activity_rsvp_deadline": "RSVP deadline",
  "create_activity_availableRsvps": "Available RSVPs",
  "no_arrival_time": "No arrival time",
  "15_minutes_before": "15 minutes before",
  "30_minutes_before": "30 minutes before",
  "45_minutes_before": "45 minutes before",
  "1_hour_before": "1 hour before",
  "1_hour_30_minutes_before": "1 hour 30 minutes before",
  "2_hours_before": "2 hours before",
  "12_hours_before": "12 hours before",
  "1_day_before": "1 day before",
  "2_days_before": "2 days before",
  "1_week_before": "1 week before",
  "hour": "hour",
  "hours": "hours",
  "minutes": "minutes",
  "no_rsvp_deadline": "No RSVP deadline",
  "cannot_be_zero_or_negative": "Cannot be zero or negative",
  "cannot_be_negative": "Cannot be negative",
  "cannot_be_decimal": "Cannot be decimal",
  "cannot_be_greater_than": "Cannot be greater than",
  "cannot_be_less_than": "Cannot be less than",
  "end_date": "end date",
  "arrival_at": "Arrival at",
  "back_to_schedule": "Back to schedule",
  "back_to": "Back to",
  "participants_select_all": "Select all",
  "send_reminder": "Send reminder",
  "reminder_sent": "Reminder sent",
  "created_successfully": "created successfully",
  "updated_successfully": "updated successfully",
  "new_weekly_training": "New weekly training",
  "event_participants_all": "All",
  "event_participants_players": "Players",
  "event_participants_admins": "Admins",
  "event_participants_coaches": "Coaches",
  "event_participants_parents": "Parents",
  "view_activity": "View activity",
  "edit_activity": "Edit activity",
  "cancel_activity": "Cancel activity",
  "cancel_activities": "Cancel activities",
  "delete_activity": "Delete activity",
  "time": "Time",
  "cancel_activity_confirmation_msg": "Are you sure you want to cancel",
  "cancel_activity_confirmation_subtitle": "This action cannot be undone.",
  "delete_activity_confirmation_msg": "Are you sure you want to delete",
  "delete_activity_confirmation_subtitle": "This action cannot be undone.",
  "these_activities": "these activities",
  "this_activity": "this activity",
  "close": "Close",
  "reschedule_activity": "Reschedule & Enable activity",
  "reschedule_activities": "Reschedule & Enable activities",
  "reschedule_activity_confirmation_msg": "Are you sure you want to reschedule & enable",
  "reschedule_activity_confirmation_subtitle": "This action cannot be undone.",
  "reschedule": "Reschedule",
  "reschedule_future_events": "Reschedule future events",
  "reset_rsvps_on_activities": "Reset RSVP on activities",
  "reset_rsvps_on_activity": "Reset RSVP on activity",
  "reset_rsvps_confirmation_msg": "You have edited the starting - ending date / time or the location. All RSVP responses will be reset for",
  "save_changes_on_trainings": "Apply changes on all trainings",
  "save_changes_confirmation_msg": "The changes will be applied on all trainings. Are you sure?",
  "delete_activities": "Delete Activities",
  "edit_event": "Edit Event",
  "edit_training": "Edit Training",
  "edit_match": "Edit Match",
  "view_post": "View Post",
  "delete_post": "Delete Post",
  "edit_post": "Edit Post",
  "the_post": "The post",
  "new_post": "New post",
  "all_teams": "All Teams",
  "post_table_published_date": "Date published",
  "post_table_title": "Title",
  "post_table_team": "Team",
  "post_table_editor": "Editor",
  "post_table_reactions": "Reactions",
  "post_table_views": "Views",
  "delete_post_warning_msg": "Are you sure you want to delete this post?",
  "create_post_text": "Text",
  "create": "Create",
  "post_edit": "Edit",
  "create_post": "Post",
  "post_training": "Training Post",
  "post_match": "Match Post",
  "post_event": "Event Post",
  "post_deleted_successfully": "The post was deleted successfully",
  "post_photo_cover": "Photo (cover)",
  "post_form_description": "Create the announcement and choose what members will see and download.",
  "post_details_title": "Announcement details",
  "post_details_description": "Add the message and choose which teams will receive it.",
  "post_media_title": "Photos and videos",
  "post_media_description": "Shown visually inside the announcement.",
  "post_media_upload": "Add photos or videos",
  "post_attachments_description": "Files members can open or download.",
  "post_attachments_upload": "Upload PDF from device",
  "post_choose_shared_files": "Choose from academy files",
  "post_shared_files_team_hint": "Select at least one team to choose from academy files.",
  "post_create_action": "Create announcement",
  "post_save_action": "Save changes",
  "share_with": "Share with",
  "share": "Share",
  "the_file": "The file",
  "the_files": "The files",
  "file": "File",
  "files": "Files",
  "files_subtitle": "Send files to teams or to specific players of your academy and manage them.",
  "size": "Size",
  "image_file": "Image",
  "video_file": "Video",
  "pdf_file": "PDF",
  "download": "Download",
  "open_file": "Open file",
  "preview_file": "Preview file",
  "file_preview_unavailable": "Preview is unavailable for this file. Use Download to open it.",
  "download_file": "Download file",
  "delete_file": "Delete file",
  "share_file": "Share file",
  "unshare_file": "Unshare file",
  "file_successfully_downloaded": "The file was downloaded successfully",
  "file_successfully_deleted": "The file was deleted successfully",
  "file_successfully_shared": "The file was shared successfully",
  "file_successfully_unshared": "The file was unshared successfully",
  "error_download_file": "Error downloading file",
  "file_download_failed_help": "The file could not be downloaded. Try again, or open it in a new tab and save it from your browser.",
  "no_files_found": "No files found.",
  "upload": "Upload",
  "upload_files": "Upload files",
  "post_attachment_upload_failed": "The announcement attachment could not be uploaded. Please try again.",
  "click_to_upload": "Click to upload",
  "drag_n_drop": "or drag and drop",
  "drop_files_here": "Drop the files here ...",
  "image_upload_files": "WEBP, SVG, PNG, JPG, HEIC or GIF (max. 800x400 px + 15 MB)",
  "video_upload_files": "MP4, MPEG or AVI (max. 15 MB)",
  "document_upload_files": "PDF (max. 15 MB)",
  "invalid_file_type": "Invalid file type. Please upload a valid file.",
  "invalid_file_size": "Invalid file size. Please upload a file smaller than 15 MB.",
  "add_file": "Add file",
  "replace_file": "Replace file",
  "club_page_title": "Academy",
  "club_page_subtitle": "Create teams, share their codes and view all the profiles of your academy's players.",
  "club_page_add_team": "Add team",
  "players_page_title": "Players",
  "players_page_subtitle": "Create player profiles, see who has connected to the app and manage their details.",
  "players_stats_total": "Total players",
  "club_stats_total": "Total teams",
  "staff_stats_total": "Total staff",
  "players_page_summary": "{{players}} players across {{teams}} teams",
  "players_export": "Export",
  "players_exporting": "Exporting...",
  "players_export_failed": "Players could not be exported.",
  "players_new_player": "New player",
  "team_required_title": "Create a team first",
  "team_required_players": "To add players, you must first create at least one team.",
  "team_required_activities": "To create activities, you must first create at least one team.",
  "players_select_team": "Select a team",
  "players_search_placeholder": "Search players",
  "players_filter_team": "Team",
  "players_filter_status": "Status",
  "players_filter_documents": "Documents",
  "players_filter_gdpr": "GDPR",
  "players_column_gdpr": "GDPR",
  "players_gdpr_accepted": "Accepted",
  "players_gdpr_missing": "Missing",
  "players_gdpr_stale": "Needs renewal",
  "players_gdpr_not_required": "Not required",
  "players_gdpr_unknown": "Unknown",
  "players_filter_accounts": "Accounts",
  "players_filter_balance": "Balance",
  "players_filter_age_group": "Age group",
  "players_columns": "Columns",
  "players_column_player": "Player",
  "players_column_team": "Team",
  "players_column_date_of_birth": "Date of birth",
  "players_column_guardian": "Guardian",
  "players_column_status": "Status",
  "players_column_documents": "Documents",
  "players_column_balance": "Balance",
  "table_sort_example_title": "Sortable, non-sortable, and disabled header composition",
  "table_sort_example_caption": "Semantic-only sorting preview; production visuals remain pending",
  "table_sort_state_none": "not sorted",
  "table_sort_state_ascending": "sorted ascending",
  "table_sort_state_descending": "sorted descending",
  "table_sort_action_ascending": "sort ascending",
  "table_sort_action_descending": "sort descending",
  "table_sort_button_label": "{{column}}, {{current}}. Activate to {{next}}.",
  "table_sort_unavailable": "{{column}} sorting is temporarily unavailable.",
  "table_sort_example_available": "Available",
  "table_sort_example_player": "Player with an especially long localized name",
  "table_sort_example_team": "Academy",
  "players_status_registered": "Registered",
  "players_status_registered_managed": "Registered · Managed by parent",
  "players_status_managed": "Managed by parent",
  "players_status_pending": "Pending",
  "players_status_unclaimed": "Unclaimed",
  "players_status_unknown": "Unknown",
  "players_documents_complete": "Complete",
  "players_documents_missing": "Missing",
  "players_documents_missing_count": "{{count}} missing",
  "players_documents_expired": "Expired",
  "players_documents_unknown": "Unknown",
  "players_balance_has_balance": "Has balance",
  "players_balance_no_balance": "No balance",
  "players_balance_unknown": "Unknown",
  "players_table_label": "Academy players",
  "players_select_all": "Select all players on this page",
  "players_select_player": "Select player",
  "players_view_player": "View player",
  "players_no_results": "No players match these filters.",
  "table_rows_per_page": "Rows per page",
  "table_pagination_of": "of",
  "select_example_title": "Page-size selector",
  "select_example_caption": "The consumer owns available values, pagination reset behavior, and the responsive footer layout.",
  "select_selected_value": "Selected page size: {{value}}",
  "pagination_example_title": "Pagination controls",
  "pagination_example_caption": "The consumer owns page state, page math, localized labels, icons, and announcements.",
  "pagination_navigation_label": "Pages",
  "pagination_first_page": "First page",
  "pagination_previous_page": "Previous page",
  "pagination_next_page": "Next page",
  "pagination_last_page": "Last page",
  "pagination_page_summary": "Page {{page}} of {{total}}",
  "players_load_failed": "Players could not be loaded.",
  "players_retry": "Retry",
  "sport": "Sport",
  "edit_team": "Edit Team",
  "team_name": "Name",
  "gender": "Gender",
  "team_code": "Code",
  "the_team": "The team",
  "create_team": "Team",
  "locked_successfully": "locked successfully",
  "unlocked_successfully": "unlocked successfully",
  "lock_team": "Lock team",
  "unlock_team": "Unlock team",
  "generate_team_code": "Generate new team code",
  "the_team_code": "The new team code",
  "generated_successfully": "generated successfully",
  "football": "Football",
  "basket": "Basket",
  "boys": "Boys",
  "girls": "Girls",
  "edit_team_info": "Edit team info",
  "edit_club_info": "Edit academy info",
  "manage_players": "Manage players",
  "add_new_player": "Add",
  "back_to_team": "Back to team",
  "move_players_to_other_teams": "Move",
  "select_teams_to_move_or_copy_players": "Select team(s) to move or copy players",
  "copy_players": "Copy",
  "move_players": "Move",
  "no_players_found": "No players found.",
  "selected_players_successfully_moved": "Selected players are successfully moved",
  "selected_players_successfully_copied": "Selected players are successfully copied",
  "error_move_selected_player": "Error on moving selected player",
  "error_copy_selected_player": "Error on copying selected player",
  "squad": "Squad",
  "team_parents": "Parents",
  "edit_profile": "Edit profile",
  "create_profile": "Create profile",
  "player_create_subtitle": "Add personal, team, medical, and document information.",
  "player_edit_subtitle": "Update personal, team, medical, and document information.",
  "player_personal_details": "Personal details",
  "player_personal_details_subtitle": "Contact details and basic player information.",
  "player_membership_details": "Team and profile",
  "player_membership_details_subtitle": "Teams, demographics, and profile photo.",
  "search": "Search",
  "enter_phone_msg": "Enter your phone number and then we'll send you a 6-digit \ncode to verify your phone number.",
  "login_through_mobile_app": "You are not authorized to use PlayerDex Manager. Please log in through the mobile app for free!",
  "otp_code": "OTP Code",
  "remember_me": "Remember me",
  "confirm_code": "Confirm Code",
  "sign_in": "Sign in",
  "loadMore": "Load More",
  "send": "Send",
  "and_every": "and every",
  "newFemale": "New",
  "and": "and",
  "updateAllFutureEvents": "Update all training series",
  "daily_training": "Daily",
  "weekly_training": "Weekly",
  "no_repeated_training": "Never",
  "athletics": "athletics",
  "basketball": "Basketball",
  "americanFootball": "American Football",
  "archery": "archery",
  "badminton": "Badminton",
  "baseball": "Baseball",
  "boxing": "Boxing",
  "cricket": "Cricket",
  "cycling": "Cycling",
  "esports": "Esports",
  "fencing": "Fencing",
  "fieldHockey": "Field Hockey",
  "gymnastics": "Gymnastics",
  "golf": "Golf",
  "handball": "Handball",
  "horseRiding": "Horse Riding",
  "iceHockey": "Ice Hockey",
  "martialArts": "Martial Arts",
  "padel": "Padel",
  "pingPong": "Ping Pong",
  "rugby": "Rugby",
  "sailing": "Sailing",
  "shootingSport": "Shooting",
  "skiing": "Skiing",
  "swimming": "Swimming",
  "tennis": "Tennis",
  "volleyball": "Volleyball",
  "waterSports": "Water Sports",
  "waterPolo": "Water Polo",
  "notifications": "Notifications",
  "notifications_title": "Notifications",
  "notifications_subtitle": "Manage parent and coach requests for app access.",
  "deny": "Deny",
  "give_access": "Give access",
  "role": "Role",
  "user": "User",
  "no_notifications_found": "No invitations found.",
  "user_invitations": "User Invitations",
  "invitation_from": "From",
  "parent": "Parent",
  "invitation_player": "Player",
  "team_admin": "Team Admin",
  "club_admin": "Academy Admin",
  "remove_club_admin": "Remove Academy Admin",
  "remove": "Remove",
  "add": "Add",
  "areYouSureYouWantToDeleteThisTeam": "Are you sure you want to delete this team",
  "deleteTeam": "Delete team",
  "couldntDeleteTeam": "Couldn't delete team",
  "pleaseMakeSureThereAreNoPlayersInTeamBeforeDeleteIt": "Please make sure there are no players in team before you delete it",
  "areYouSureYouWantToDeleteThisPlayer": "Are you sure you want to delete this player",
  "mixed": "Mixed",
  "removeParent": "Remove Parent",
  "areYouSureYouWantToDeleteThisParent": "Are you sure you want to delete this parent",
  "fromPlayer": "from player",
  "remove_user": "Remove user",
  "removePlayerFromUser": "Remove player from the user",
  "areYouSureYouWantToRemoveThisPlayerFromTheUser": "Are you sure you want to remove this player from the user",
  "removePlayerFromTeam": "Remove player from the team",
  "removeStaffFromTeam": "Remove staff member from the team",
  "removeStaffFromTeamConfirmation": "Are you sure you want to remove {{name}} from {{team}}?",
  "areYouSureYouWantToRemoveThisPlayer": "Are you sure you want to remove {{firstName}} {{lastName}} from the team {{team}}?",
  "fromTheTeam": "from the team",
  "successfullyDeletedPlayer": "Successfully deleted the player",
  "successfullyUserFromPlayer": "Successfully removed the player from the user",
  "successfullyAddedPlayer": "The player was created successfully",
  "add_product": "Add Product",
  "shop": "Shop",
  "shop_page_subtitle": "Create products and subscriptions, charge them to members and track your academy's revenue.",
  "back_to_shop": "Back to shop",
  "product_not_found": "Product not found.",
  "product_name": "Product Name",
  "stock": "Stock",
  "paid": "Paid",
  "back_to_products": "Back to products",
  "no_products_found": "No products found.",
  "shop_add_product_details": "Product details",
  "shop_add_product_details_subtitle": "The details of the product",
  "shop_add_product_name_placeholder": "Name of the product",
  "shop_add_product_price_and_stock": "Price and stock",
  "shop_add_product_price_and_stock_subtitle": "The price and the amount of the products",
  "shop_add_product_description": "Description",
  "shop_add_product_description_subtitle": "The description of the product",
  "shop_add_product_photo": "Photo",
  "shop_add_product_photo_subtitle": "Update your product photo",
  "shop_add_product_price_and_stock_placeholder": "Add stock of product. Live it empty if there is none.",
  "characters_left": "Character left",
  "product_successfully_created": "Product successfully created",
  "create_product": "Create Product",
  "edit_product": "Edit Product",
  "delete_product": "Delete Product",
  "create_payment": "New Payment",
  "product_successfully_updated": "Product has been updated successfully",
  "hide_deleted_players": "Hide deleted players",
  "show_deleted_players": "Show deleted players",
  "no_payments_found": "No payments found.",
  "add_payments": "Add payments",
  "add_payments_subtitle": "Create payment from the selected product",
  "payment_method": "Payment method",
  "cash": "Cash",
  "card": "Card",
  "payment_transfer": "Transfer",
  "discount_type": "Discount type",
  "fixed": "Flat",
  "percent": "Percent",
  "discount": "Discount",
  "new_payment": "New payment",
  "durationInMonths": "Duration In months",
  "order_created_successfully": "Order has been successfully created",
  "initialAmount": "Initial Amount",
  "player_table_column": "Player",
  "payment_type": "Payment type",
  "payment_status": "Payment status",
  "draft": "Scheduled",
  "undo_payment": "Undo payment",
  "shop_loading_impact": "Calculating the impact…",
  "shop_review_impact": "Review current impact",
  "shop_impact_unavailable": "The impact could not be calculated. Review it again before confirming.",
  "shop_impact_changed": "These records changed since your preview. Review the updated impact and confirm again.",
  "SHOP_ACTION_CHANGED": "These records changed since your preview. Review the updated impact and confirm again.",
  "shop_impact_all_time": "This action includes all dates, beyond the selected season and filters.",
  "shop_affected_orders": "Linked orders",
  "shop_deleted_orders": "Orders deleted",
  "shop_affected_payments": "Payments affected",
  "shop_deleted_payments": "Payments deleted",
  "shop_monthly_payments": "Monthly payments",
  "shop_revenue_change": "Collected revenue change",
  "shop_outstanding_change": "Outstanding balance change",
  "shop_payment_total_change": "Payment total change",
  "shop_order_value_change": "Order value change",
  "shop_payment_returns_to": "New payment status",
  "shop_undo_schedule_note": "The original due date is kept. A past due date makes the payment overdue; a future date makes it scheduled.",
  "shop_financial_changes_note": "Changes above apply across all dates. Payment totals exclude cancelled payments; outstanding balances include scheduled and overdue payments. Order values are shown separately.",
  "shop_no_refund_note": "This only changes your records. It does not refund or transfer money.",
  "shop_undo_paid_note": "Reopen this payment as unpaid using its saved amount and due date. The recorded collection is removed from revenue. Other payments and installments stay unchanged.",
  "shop_undo_cancelled_note": "Restore this cancelled payment as unpaid using its saved amount and due date. It becomes part of the outstanding balance again. Other payments and installments stay unchanged.",
  "shop_delete_order_note": "Delete this order and all its payments, including paid payments, initial payments, monthly payments and installments. Their recorded revenue, outstanding balances and totals will be removed. Product stock stays unchanged.",
  "shop_product_delete_scope": "What should be deleted?",
  "shop_delete_catalog_only": "Only remove from the shop",
  "shop_delete_product_everywhere": "Also remove from existing orders",
  "shop_delete_catalog_note": "The product is removed from the shop. Existing orders, payment schedules, collected revenue and totals stay unchanged.",
  "shop_delete_cascade_note": "Remove this product from every linked order, including paid orders. Empty orders and all their payments are deleted. For orders with other products, all payment amounts, including paid and cancelled amounts, decrease proportionally; dates and statuses are kept. This includes monthly payments and installments.",
  "due": "Overdue",
  "shop_all_payments": "All payments (collected / total)",
  "shop_totals_unavailable": "Payment totals are unavailable.",
  "SHOP_PAYMENT_SNAPSHOT_UNAVAILABLE": "This payment has no saved product details. Its changes cannot be calculated safely.",
  "SHOP_PAYMENT_ORDER_UNAVAILABLE": "The order linked to this payment is unavailable. Refresh the page and review it again.",
  "SHOP_PAYMENT_NOT_REOPENABLE": "Only paid or cancelled payments can be reopened. Refresh the page to see the current status.",
  "SHOP_ACTION_INVALID_INPUT": "This action is unavailable. Refresh the page and try again.",
  "SHOP_ACTION_INVALID_AMOUNT": "The saved amounts are inconsistent. Review the order and payment amounts before continuing.",
  "cancelled": "Cancelled",
  "payment_already_paid": "Payment already paid",
  "pay_this_payment": "Pay this payment",
  "are_you_sure_want_to_pay_this_payment": "Are you sure that you want to pay this payment?",
  "pay": "Pay",
  "payment_paid_successfully": "Payment successfully paid",
  "pay_payment": "Pay payment",
  "send_notification": "Send notification",
  "are_you_sure_want_to_send_notification_for_this_overdue_payment": "Are you sure you want to send notification for this overdue payment?",
  "notification_sent_successfully": "Notification sent successfully",
  "academy_revenue": "Academy revenue",
  "academy_revenue_subtitle": "Track collected member payments and contact overdue payers.",
  "collected_revenue": "Collected revenue",
  "revenue_transactions": "Payments received",
  "revenue_period": "Revenue period",
  "revenue_grouping": "Revenue grouping",
  "revenue_today": "Today",
  "revenue_this_week": "This week",
  "revenue_this_month": "This month",
  "revenue_season": "Season",
  "revenue_custom": "Custom",
  "revenue_daily": "Daily",
  "revenue_weekly": "Weekly",
  "revenue_monthly": "Monthly",
  "no_revenue_data": "No paid member payments were recorded in this period.",
  "legacy_revenue_note": "Some historical payments use their last recorded update as the payment date.",
  "notify_overdue_payers": "Notify overdue payers",
  "overdue_reminder_confirmation": "Send one reminder per player and currency for all eligible overdue payments?",
  "eligible_payers": "Eligible payers",
  "overdue_payments": "Overdue payments",
  "overdue_balance": "Overdue balance",
  "payers": "payers",
  "payment_reminder_cooldown_note": "A payer who was reminded in the last 24 hours will be skipped.",
  "payment_reminders_sent": "Notifications sent",
  "payment_reminders_skipped": "Payers skipped",
  "payment_reminders_failed": "Deliveries failed",
  "notification_sent": "Notification sent",
  "create_product_subscription": "Subscription Product",
  "create_product_teamware": "Teamware Product",
  "create_product_event": "Event Product",
  "create_product_tournament": "Tournament Product",
  "create_product_tours": "Tours Product",
  "create_product_other": "Other Product",
  "per_month": "month",
  "repeats_monthly": "Repeats monthly",
  "total": "Total",
  "per_player": "Per Player",
  "shop_add_product_price": "Product price",
  "cancel_this_payment": "Cancel payment",
  "are_you_sure_want_to_cancel_this_payment": "Are you sure that you want to cancel this payment",
  "payment_cancelled_successfully": "Payment cancelled successfully",
  "order_successfully_deleted": "Order successfully deleted",
  "delete_order": "Delete order",
  "are_you_sure_want_to_delete_this_order": "Are you sure you want to delete this order?",
  "all_types": "All Types",
  "all_coaches": "All Coaches",
  "all_players": "All Players",
  "all_categories": "All Categories",
  "category": "Category",
  "show_all": "Show all",
  "cancel_payment": "Cancel payment",
  "payments": "Payments",
  "orders": "Orders",
  "paidOn": "Paid on",
  "product_successfully_delete": "Product deleted successfully",
  "error_not_enough_stock": "Error not enough stock",
  "need_to_select_players": "You need to select at least one player",
  "going": "Going",
  "notAttended": "Not Attended",
  "notGoing": "Not Going",
  "notAnswered": "Not Answered",
  "attended_player": "Attended",
  "notAttended_player": "Not attended",
  "activities": "Activities",
  "send_code": "Send code",
  "insert_code": "Insert code",
  "contacts": "Contacts",
  "never_loggedIn": "No connection",
  "connected": "Last seen",
  "online": "Online",
  "managed_by_parents": "Managed by parent",
  "order_summary": "Order summary",
  "assignments": "Assignments",
  "deleted_player": "Deleted player",
  "are_you_sure_you_want_to_logout": "Are you sure you want to logout?",
  "home_match": "Home Match",
  "add_option": "Add option",
  "assign": "Assign",
  "copy_field": "Copy field",
  "delete_field": "Delete field",
  "drag_field": "Drag to reorder",
  "field_type": "Field type",
  "remove_option": "Remove option",
  "selection_rule": "Selection rule",
  "selection_count": "Number of choices",
  "select_at_least": "Select at least",
  "select_equals_to": "Select equals to",
  "select_more_than": "Select more than",
  "who_should_make_the_submission": "Who should make the submission",
  "create_template": "Create template",
  "create_form_to_be_submitted": "Create form to be submitted here.",
  "form_title": "Form title",
  "form_description": "Form description",
  "form_due_date": "Form due date",
  "player_form": "Player",
  "profile": "Player",
  "profiles": "Profiles",
  "form_title_placeholder": "Form title",
  "form_description_placeholder": "Enter a description...",
  "form_due_date_placeholder": "Enter date",
  "question": "Question",
  "required": "Required",
  "option": "Option",
  "long_text": "Long text",
  "short_text": "Short text",
  "number": "Number",
  "multiple_choice": "Multiple  choice",
  "linear_scale": "Linear scale",
  "checkboxes": "Checkboxes",
  "dropdown": "Dropdown",
  "phone": "Phone",
  "yes_no": "No/Yes",
  "legal": "Legal",
  "file_upload": "File upload",
  "form_successfully": "Form successfully created",
  "no": "No",
  "yes": "Yes",
  "forms": "Forms",
  "no_forms_found": "No forms found.",
  "assign_form": "Assign form",
  "no_assignments_found": "No assignments found.",
  "assignment_was_successful": "Assignment was successful",
  "submitter": "Submitter",
  "add_form": "Add form",
  "are_you_sure_you_want_to_delete_this_assignment": "Are you sure you want to delete this assignment?",
  "delete_assignment": "Delete assignment",
  "assignment_successfully_deleted": "The assignment has been deleted successfully",
  "description": "Description",
  "answer": "Answer",
  "reject": "Reject",
  "approve": "Approve",
  "reject_assignment": "Reject assignment",
  "view_assignment": "View assignment",
  "are_you_sure_you_want_to_reject_this_assignment": "Are you sure you want to reject this assignment",
  "newMessage": "New message",
  "please_send_message": "Please send a message",
  "are_you_sure_want_to_delete_this_message": "Are you sure you want to delete this message?",
  "delete_message": "Delete message",
  "messageDeletedSuccessfully": "Message deleted successfully",
  "messageNotDeleted": "Message not deleted",
  "createdAt": "Created at",
  "updatedAt": "Updated at",
  "reviewed": "Reviewed",
  "waitingForApproval": "Waiting for approval",
  "rejection_reason": "Rejection reason",
  "back_to_submitter": "Back to submitter",
  "select_less_than": "Select less than",
  "none": "None",
  "dateSubmitted": "Date submitted",
  "forms_page_subtitle": "Collect information from parents and players, or create evaluations for coaches to fill in.",
  "rejecting_assignment_successful": "Rejecting assignment was successfully",
  "approving_assignment_successful": "Approving assignment was successful",
  "users_successfully_added": "Users successfully added",
  "view_product": "View product",
  "view_form": "View form",
  "view_payments": "View payments",
  "view_assignments": "View assignments",
  "delete_form": "Delete form",
  "view_team": "View team",
  "waitingAproval": "Waiting Approval",
  "backToSubmitter": "Back to submitter",
  "if_you_are_a_parent_to_a_player_go_back_to_sign_up_as_a_parent_instead": "If you 're a parent to a player, go back to sign up as a parent instead",
  "add_match": "Add match",
  "add_matches": "Add matches",
  "update_fixture": "Update fixture",
  "update_fixture_match": "Update fixture match",
  "home_team": "Home team",
  "away_team": "Away team",
  "match_date": "Match date",
  "match_time": "Match time",
  "match_score": "Match score",
  "match_status": "Match status",
  "match_venue": "Match venue",
  "competition_format": "Format",
  "update_competition": "Update competition",
  "new_competition": "New Competition",
  "competition_name": "Name",
  "no_name": "<No Name>",
  "season": "Season",
  "league_name": "Name",
  "error_creating_league": "Error creating league",
  "league_successfully_created": "League successfully created",
  "error_updating_league": "Error updating league",
  "league_successfully_updated": "League successfully updated",
  "error_updating_league_competition": "Error updating league competition",
  "league_competition_successfully_update": "League competition successfully updated",
  "error_updating_league_fixture_match": "Error updating league fixture match",
  "league_fixture_match_successfully_update": "League fixture match has been successfully updated",
  "error_updating_league_fixture": "Error updating league fixture",
  "league_fixture_successfully_update": "League fixture successfully updated",
  "cup_league": "Cup",
  "tournament_league": "Tournament",
  "league_league": "League",
  "fixture_name": "Fixture name",
  "region": "Region",
  "cancel_future_events": "Cancel future events",
  "delete_future_events": "Delete future events",
  "and_for": "and for",
  "successfully": "successfully",
  "deleted_succesfully": "deleted successfully",
  "cannot_be_empty": "cannot be empty",
  "cannot_be_in_past": "cannot be in the past",
  "cannot_be_in_future": "cannot be in the future",
  "cannot_be_after": "cannot be after",
  "cannot_be_before_start_date": "cannot be before starting date",
  "cannot_be_after_end_date": "cannot be after ending date",
  "cannot_be_after_end_of_season": "cannot be after the end of the season",
  "are_you_sure_want_to_delete_this_form": "Are you sure you want to delete this form?",
  "form_has_been_deleted_successfully": "Form has been deleted successfully",
  "venue_location": "Venue location",
  "saved_match_locations": "Saved Match Locations (up to 5)",
  "sender": "Sender",
  "receiver": "Receiver",
  "add_opponent": "Add opponent",
  "opponents_page_title": "Opponents",
  "opponents_page_subtitle": "Manage your opponents",
  "allClubs": "All Academies",
  "accept": "Accept",
  "answer_invitation": "Answer invitation",
  "how_you_would_like_to_answer_to": "How you would to like to answer to",
  "opponent_invitation_was_successfully_accepted": "Opponent invitation was successfully accepted",
  "opponent_invitation_was_successfully_rejected": "Opponent invitation was successfully rejected",
  "accepted": "Accepted",
  "opponents_was_successfully_invited": "Opponents was successfully invited",
  "learn_how": "Learn how",
  "from_you": "from you",
  "denied": "Denied",
  "no_opponent_attached": "No opponents found for selected team",
  "the_field": "The field",
  "delete_this_offer": "Delete this offer?",
  "decline_this_offer": "Decline this offer?",
  "view_offer": "View offer",
  "counter_offer": "Counter offer",
  "accept_offer": "Accept offer",
  "reject_offer": "Reject offer",
  "delete_offer": "Delete offer",
  "add_field": "Add field",
  "delete_opponent": "Delete opponent",
  "are_you_sure_you_want_to_delete_opponent": "Are you sure you want to delete the opponent?",
  "opponent_invitation_was_successfully_deleted": "Opponent was successfully deleted",
  "successfully_submitted_counteroffer": "Successfully submitted counteroffer",
  "training_capital": "TRAINING",
  "match_capital": "MATCH",
  "event_capital": "EVENT",
  "team_coach": "Team coach",
  "choose_roster": "Choose Roster",
  "reject_button": "Reject",
  "totals": "Totals",
  "team_attendances": "Attendances",
  "point_guard": "Point guard",
  "shooting_guard": "Shooting guard",
  "small_forward": "Small forward",
  "power_forward": "Power forward",
  "center": "Center",
  "to": "to",
  "no_activities_found": "No activities found.",
  "no_attendances_found": "No attendances found.",
  "activities_team": "Activities",
  "delete_notes": "Delete notes",
  "edit_notes": "Edit notes",
  "are_you_sure_want_to_delete_these_notes": "Are you sure you want to delete these notes?",
  "notes_successfully_deleted": "Notes successfully deleted",
  "notes_successfully_updated": "Notes successfully updated",
  "notes_successfully_created": "Notes successfully created",
  "rsvp": "RSVP",
  "deleted_product": "Deleted Product",
  "profile_notes_placeholder": "Add notes for this athlete here...",
  "your_account_does_not_belong_to_a_club": "Your account does not belong to an academy. Please contact your academy administrator.",
  "last_club_admin": "Last Academy Admin",
  "last_club_admin_information_message": "is the last academy admin of the academy. Please add another one and then remove this one.",
  "club_admin_remove_message1": "Are you sure you want to remove the user",
  "club_admin_remove_message2": "with mobile number",
  "club_admin_remove_message3": "as academy admin?",
  "club_admin_successfully_removed": "Academy admin was successfully removed",
  "club_admin_successfully_created": "Academy admin was successfully created",
  "error_creating_club_admin": "Error creating academy admin",
  "error_creating_team_admin": "Error creating team admin",
  "error_creating_coach": "Error creating coach",
  "founded": "Founded",
  "premium": "Premium",
  "isPremium": "Is premium?",
  "roles_admin": "Roles Admin",
  "roles_permissions_admin": "Roles Permissions Admin Panel",
  "permissions": "Permissions",
  "permissions_updated": "The role permissions have been successfully updated.",
  "club_name": "Name",
  "clubs_admin": "Academies Admin",
  "clubs_admin_panel": "Academies Admin Panel",
  "no_clubs_found": "No academies found.",
  "new_club": "New Academy",
  "register_user": "Register User",
  "domain_requests_admin": "Domain Requests",
  "domain_requests_admin_panel": "\"Ask us to set it up\" Domain Requests",
  "no_domain_requests_found": "No domain requests found.",
  "domain_request_club_column": "Academy",
  "domain_request_hostname_column": "Requested domain",
  "domain_request_status_column": "Status",
  "domain_request_requested_at_column": "Requested",
  "register": "Register",
  "create_user": "User",
  "edit_club": "Edit Academy",
  "club_manager": "Academy Manager",
  "add_club_admin": "Add Academy Admin",
  "attach_club_admin": "Academy Admin",
  "the_coach": "The coach",
  "the_team_admin": "The team admin",
  "the_club_admin": "The academy admin",
  "create_club": "Academy",
  "create_a_club": "Create Academy",
  "billing": "Billing",
  "billing_page_subtitle": "Manage your academy’s invoice details, subscription and payments.",
  "billing_page_loading": "Loading invoice details and subscription…",
  "billing_subtitle": "Subscription and payments",
  "club": "Academy",
  "enabled": "Enabled",
  "disabled": "Disabled",
  "trial_ends": "Trial ends",
  "current_period_ends": "Current period ends",
  "past_due_since": "Payment overdue since",
  "start_subscription": "Start subscription",
  "open_billing_portal": "Manage subscription",
  "refresh": "Refresh",
  "retry": "Retry",
  "billing_no_access": "Only authorised academy staff can view subscription and payment details.",
  "billing_rollout_paused": "Your academy currently has full access. Subscriptions will be available here.",
  "billing_state_loading": "Loading subscription details…",
  "billing_state_ready_to_start": "A 30-day free trial is available, with no card required to start. Add a card before it ends to keep full access. Any amount due will be charged automatically after the trial unless you cancel beforehand.",
  "billing_state_early_signup": "Add your card now to set up your subscription. Billing starts on the date below, with no additional trial.",
  "billing_starts": "Billing starts",
  "billing_state_no_subscription": "Your academy has no active subscription. Any amount due, including discounts, is shown before confirmation. A new free trial is not available.",
  "billing_state_checkout_not_open": "Subscription setup is not available yet. Please try again later.",
  "billing_state_checkout_not_open_until": "Subscription setup will be available on {date}.",
  "billing_state_trialing": "Your free trial is active. You have full access until the trial ends.",
  "billing_state_active": "The subscription is active with full access.",
  "billing_state_past_due_grace": "A subscription payment needs attention. Your academy still has full access for now. Complete the payment to avoid restrictions.",
  "billing_state_past_due_read_only": "A subscription payment is pending. You can browse Manager and view academy information, but changes to academy data are restricted.",
  "billing_state_read_only": "You can browse Manager and view academy information. Changes to academy data are restricted until full access is restored.",
  "billing_state_inactive": "Full access needs to be restored. You can still browse Manager and view academy information, but changes to academy data are restricted.",
  "billing_state_paused": "Your subscription is paused. You can still browse Manager and view academy information, but changes to academy data are restricted.",
  "billing_state_cancel_scheduled": "Your subscription is set to end at the end of the current period. You have full access until then.",
  "billing_access_full": "Full access",
  "billing_access_read_only": "View-only access",
  "billing_access_inactive": "Full access suspended",
  "billing_commercial_terms": "€50/month or €500/year, including VAT where applicable. You can enter a promotion code when subscribing.",
  "error_loading_billing": "We couldn’t load your subscription details. Please refresh and try again.",
  "error_starting_subscription": "We couldn’t open subscription setup. Please try again.",
  "error_opening_portal": "We couldn’t open subscription management. Please try again.",
  "billing_missing_checkout_url": "We couldn’t open subscription setup. Please try again.",
  "billing_missing_portal_url": "We couldn’t open subscription management. Please try again.",
  "billing_country_gr": "Greece",
  "billing_country_cy": "Cyprus",
  "billing_identity_checkout_in_progress": "Subscription setup is already in progress. Complete it or try again shortly.",
  "error_updating_billing_email": "We couldn’t update your billing email. Please try again.",
  "not_subscribed": "Not subscribed",
  "stripe_status_active": "Active",
  "stripe_status_trialing": "Free trial",
  "stripe_status_past_due": "Payment pending",
  "stripe_status_canceled": "Canceled",
  "stripe_status_unpaid": "Unpaid",
  "stripe_status_incomplete": "Setup incomplete",
  "stripe_status_incomplete_expired": "Setup expired",
  "stripe_status_paused": "Paused",
  "ROLE_ALREADY_EXISTS": "The role already exists",
  "USER_NOT_ADMIN": "The user is not an admin",
  "USER_NOT_AUTHORISED": "The user is not authorized",
  "CLUB_ALREADY_EXISTS": "The academy already exists",
  "CLUB_NOT_FOUND": "The academy was not found",
  "CLUB_INVALID_INPUT": "The academy input is invalid",
  "CLUB_CREATION_FAILED": "The academy creation failed",
  "CLUB_UPDATE_FAILED": "The academy update failed",
  "CLUB_DELETION_FAILED": "The academy deletion failed",
  "USER_NOT_CLUB_ADMIN": "The user is not an academy admin",
  "USER_THE_ONLY_CLUB_ADMIN": "The user can not be removed, because is the only academy admin. Please add another one and then proceed to delete",
  "LEAGUE_ALREADY_EXISTS": "The league already exists",
  "LEAGUE_NOT_FOUND": "The league was not found",
  "LEAGUE_INVALID_INPUT": "The league input is invalid",
  "LEAGUE_CREATION_FAILED": "The league creation failed",
  "LEAGUE_UPDATE_FAILED": "The league update failed",
  "LEAGUE_DELETION_FAILED": "The league deletion failed",
  "COMPETITION_ALREADY_EXISTS": "The competition already exists",
  "COMPETITION_NOT_FOUND": "The competition was not found",
  "COMPETITION_INVALID_INPUT": "The competition input is invalid",
  "COMPETITION_CREATION_FAILED": "The competition creation failed",
  "COMPETITION_UPDATE_FAILED": "The competition update failed",
  "COMPETITION_DELETION_FAILED": "The competition deletion failed",
  "FIXTURE_ALREADY_EXISTS": "The fixture already exists",
  "FIXTURE_NOT_FOUND": "The fixture was not found",
  "FIXTURE_INVALID_INPUT": "The fixture input is invalid",
  "FIXTURE_CREATION_FAILED": "The fixture creation failed",
  "FIXTURE_UPDATE_FAILED": "The fixture update failed",
  "FIXTURE_DELETION_FAILED": "The fixture deletion failed",
  "FIXTURE_MATCH_ALREADY_EXISTS": "The fixture match already exists",
  "FIXTURE_MATCH_NOT_FOUND": "The fixture match was not found",
  "FIXTURE_MATCH_INVALID_INPUT": "The fixture match input is invalid",
  "FIXTURE_MATCH_CREATION_FAILED": "The fixture match creation failed",
  "USER_ALREADY_EXISTS": "A user with these details already exists.",
  "USER_NOT_FOUND": "The user was not found",
  "USER_INVALID_INPUT": "The user input is invalid",
  "USER_CREATION_FAILED": "The user creation failed",
  "USER_UPDATE_FAILED": "The user update failed",
  "USER_DELETION_FAILED": "The user deletion failed",
  "TEAM_ALREADY_EXISTS": "The team already exists",
  "TEAM_NOT_FOUND": "The team was not found",
  "TEAM_INVALID_INPUT": "The team input is invalid",
  "TEAM_CREATION_FAILED": "The team creation failed",
  "TEAM_UPDATE_FAILED": "The team update failed",
  "TEAM_DELETION_FAILED": "The team deletion failed",
  "TEAM_LOCKED": "The team is locked. You can not join.",
  "CANNOT_REMOVE_LAST_ADMIN": "Cannot remove last admin",
  "USER_NOT_TEAM_ADMIN": "The user is not a team admin",
  "USER_ALREADY_TEAM_ADMIN": "The user is already a team admin",
  "USER_NOT_COACH": "The user is not a coach",
  "USER_ALREADY_COACH": "The user is already a coach",
  "MATCH_ALREADY_EXISTS": "The match already exists",
  "MATCH_NOT_FOUND": "The match was not found",
  "MATCH_INVALID_INPUT": "The match input is invalid",
  "MATCH_CREATION_FAILED": "The match creation failed",
  "MATCH_UPDATE_FAILED": "The match update failed",
  "MATCH_DELETION_FAILED": "The match deletion failed",
  "MATCH_REPORT_ALREADY_EXISTS": "The match has a submitted score or match report",
  "MATCH_REPORT_NOT_FOUND": "The match report was not found",
  "MATCH_REPORT_INVALID_INPUT": "The match report input is invalid",
  "MATCH_REPORT_CREATION_FAILED": "The match report creation failed",
  "MATCH_REPORT_UPDATE_FAILED": "The match report update failed",
  "MATCH_REPORT_DELETION_FAILED": "The match report deletion failed",
  "INVITATION_ALREADY_EXISTS": "The invitation already exists",
  "INVITATION_NOT_FOUND": "The invitation was not found",
  "INVITATION_INVALID_INPUT": "The invitation input is invalid",
  "INVITATION_CREATION_FAILED": "The invitation creation failed",
  "INVITATION_UPDATE_FAILED": "The invitation update failed",
  "INVITATION_DELETION_FAILED": "The invitation deletion failed",
  "FRIENDLY_INVITATION_ALREADY_EXISTS": "The friendly invitation already exists",
  "FRIENDLY_INVITATION_NOT_FOUND": "The friendly invitation was not found",
  "FRIENDLY_INVITATION_INVALID_INPUT": "The friendly invitation input is invalid",
  "FRIENDLY_INVITATION_CREATION_FAILED": "The friendly invitation creation failed",
  "FRIENDLY_INVITATION_UPDATE_FAILED": "The friendly invitation update failed",
  "FRIENDLY_INVITATION_DELETION_FAILED": "The friendly invitation deletion failed",
  "FRIENDLY_MATCH_ALREADY_EXISTS": "The friendly match already exists",
  "FRIENDLY_MATCH_NOT_FOUND": "The friendly match was not found",
  "FRIENDLY_MATCH_INVALID_INPUT": "The friendly match input is invalid",
  "FRIENDLY_MATCH_CREATION_FAILED": "The friendly match creation failed",
  "FRIENDLY_MATCH_UPDATE_FAILED": "The friendly match update failed",
  "FRIENDLY_MATCH_DELETION_FAILED": "The friendly match deletion failed",
  "FRIENDLY_MATCH_RESULT_ALREADY_EXISTS": "The friendly match result already exists",
  "FRIENDLY_MATCH_RESULT_NOT_FOUND": "The friendly match result was not found",
  "FRIENDLY_MATCH_RESULT_INVALID_INPUT": "The friendly match result input is invalid",
  "FRIENDLY_MATCH_RESULT_CREATION_FAILED": "The friendly match result creation failed",
  "FRIENDLY_MATCH_RESULT_UPDATE_FAILED": "The friendly match result update failed",
  "FRIENDLY_MATCH_RESULT_DELETION_FAILED": "The friendly match result deletion failed",
  "FRIENDLY_MATCH_REQUEST_ALREADY_EXISTS": "The friendly match request already exists",
  "FRIENDLY_MATCH_REQUEST_NOT_FOUND": "The friendly match request was not found",
  "FRIENDLY_MATCH_REQUEST_INVALID_INPUT": "The friendly match request input is invalid",
  "FRIENDLY_MATCH_REQUEST_CREATION_FAILED": "The friendly match request creation failed",
  "FRIENDLY_MATCH_REQUEST_UPDATE_FAILED": "The friendly match request update failed",
  "FRIENDLY_MATCH_REQUEST_DELETION_FAILED": "The friendly match request deletion failed",
  "EVENT_ALREADY_EXISTS": "The event already exists",
  "EVENT_NOT_FOUND": "The event was not found",
  "EVENT_INVALID_INPUT": "The event input is invalid",
  "EVENT_CREATION_FAILED": "The event creation failed",
  "EVENT_UPDATE_FAILED": "The event update failed",
  "EVENT_DELETION_FAILED": "The event deletion failed",
  "INVALID_RSVP_DEADLINE": "The RSVP deadline is invalid",
  "RSVP_TOO_EARLY": "RSVP is too early",
  "RSVP_AFTER_ARRIVAL": "RSVP cannot be submitted after arrival",
  "INVALID_ARRIVAL_DATE": "Invalid arrival date",
  "ARRIVAL_TOO_EARLY": "Arrival time is too early",
  "INVALID_FROM_DATE": "Invalid start date",
  "FROM_DATE_IN_PAST": "Start date cannot be in the past",
  "INVALID_TO_DATE": "Invalid end date",
  "INVALID_OFFSET": "Invalid offset value on arrival or rsvp deadline.",
  "FILE_NOT_FOUND": "The file was not found",
  "FILE_TICKET_NOT_FOUND": "The shared file was not found",
  "FILE_UPLOAD_UNAUTHORISED": "The user is not authorized to upload a file",
  "FILE_DELETE_UNAUTHORISED": "The user is not authorized to delete a file",
  "INVALID_FILE_TYPE": "The file type is invalid",
  "FILE_UPLOAD_FAILED": "The file upload failed",
  "FILE_METADATA_DELETE_FAILED": "The file metadata deletion failed",
  "FILE_DELETE_FAILED": "The file deletion failed",
  "FORM_ALREADY_EXISTS": "The form already exists",
  "FORM_NOT_FOUND": "The form was not found",
  "FORM_INVALID_INPUT": "The form input is invalid",
  "FORM_CREATION_FAILED": "The form creation failed",
  "FORM_UPDATE_FAILED": "The form update failed",
  "FORM_DELETION_FAILED": "The form deletion failed",
  "FORM_CONTAINS_ASSIGNMENTS": "The form contains assignments",
  "ANSWER_FORM_ALREADY_EXISTS": "The answer form already exists",
  "ANSWER_FORM_NOT_FOUND": "The answer form was not found",
  "ANSWER_FORM_INVALID_INPUT": "The answer form input is invalid",
  "ANSWER_FORM_NOT_AUTHORISED": "The user is not authorized to answer the form",
  "ANSWER_FORM_CREATION_FAILED": "The answer form creation failed",
  "ANSWER_FORM_UPDATE_FAILED": "The answer form update failed",
  "ANSWER_FORM_DELETION_FAILED": "The answer form deletion failed",
  "POST_ALREADY_EXISTS": "The post already exists",
  "POST_NOT_FOUND": "The post was not found",
  "POST_INVALID_INPUT": "The post input is invalid",
  "POST_CREATION_FAILED": "The post creation failed",
  "POST_CREATION_UNAUTHORISED": "The user is not authorized to create the post",
  "POST_UPDATE_FAILED": "The post update failed",
  "POST_DELETION_FAILED": "The post deletion failed",
  "POST_DELETE_UNAUTHORISED": "The user is not authorized to delete the post",
  "POST_EDIT_UNAUTHORISED": "The user is not authorized to edit the post",
  "REACTION_ALREADY_EXISTS": "The reaction already exists",
  "REACTION_NOT_FOUND": "The reaction was not found",
  "REACTION_INVALID_INPUT": "The reaction input is invalid",
  "REACTION_CREATION_FAILED": "The reaction creation failed",
  "REACTION_UPDATE_FAILED": "The reaction update failed",
  "REACTION_DELETION_FAILED": "The reaction deletion failed",
  "INVALID_REACTION_TYPE": "The reaction type is invalid",
  "PROFILE_ALREADY_EXISTS": "The profile already exists",
  "PROFILE_NOT_FOUND": "The profile was not found",
  "PROFILE_INVALID_INPUT": "The profile input is invalid",
  "PROFILE_CREATION_FAILED": "The profile creation failed",
  "PROFILE_UPDATE_FAILED": "The profile update failed",
  "PROFILE_DELETION_FAILED": "The profile deletion failed",
  "PROFILE_CREATE_UNAUTHORISED": "The user is not authorized to create the profile",
  "PROFILE_DELETE_UNAUTHORISED": "The user is not authorized to delete the profile",
  "PROFILE_PARENT_NOT_FOUND": "The parent was not found",
  "PROFILE_PARENT_DELETE_UNAUTHORISED": "The user is not authorized to delete the parent",
  "PROFILE_USER_NOT_FOUND": "The user was not found",
  "PROFILE_ALREADY_CLAIMED": "The profile is already claimed the invitation",
  "PROFILE_ONLY_ONE_TEAM": "The profile should be at least in one team",
  "RSVP_ALREADY_EXISTS": "The RSVP already exists",
  "RSVP_NOT_FOUND": "The RSVP was not found",
  "RSVP_INVALID_INPUT": "The RSVP input is invalid",
  "RSVP_CREATION_FAILED": "The RSVP creation failed",
  "RSVP_UPDATE_FAILED": "The RSVP update failed",
  "RSVP_DELETION_FAILED": "The RSVP deletion failed",
  "RSVP_CANNOT_ANSWER_DEADLINE_PASSED": "The RSVP cannot be answered because the deadline is passed.",
  "RSVP_CANNOT_ANSWER_EVENT_CANCELLED": "The RSVP cannot be answered because the activity is cancelled.",
  "RSVP_FULL": "The RSVP list is full for this activity.",
  "RSVP_UNAUTHORISED": "The user is not authorized to answer to RSVP",
  "ORDER_ALREADY_EXISTS": "The order already exists",
  "ORDER_NOT_FOUND": "The order was not found",
  "ORDER_INVALID_INPUT": "The order input is invalid",
  "ORDER_CREATION_FAILED": "The order creation failed",
  "ORDER_UPDATE_FAILED": "The order update failed",
  "ORDER_DELETION_FAILED": "This order cannot be deleted because it contains a paid payment.",
  "ORDER_UNAUTHORISED": "The user is not authorized to delete the order",
  "PAYMENT_ALREADY_EXISTS": "The payment already exists",
  "PAYMENT_NOT_FOUND": "The payment was not found",
  "PAYMENT_INVALID_INPUT": "The payment input is invalid",
  "PAYMENT_CREATION_FAILED": "The payment creation failed",
  "PAYMENT_UPDATE_FAILED": "The payment update failed",
  "PAYMENT_DELETION_FAILED": "The payment deletion failed",
  "PAYMENT_UNAUTHORISED": "The user is not authorized to pay or cancel a payment",
  "PAYMENT_ALREADY_CANCELLED": "The payment is already cancelled",
  "PAYMENT_ALREADY_PAID": "The payment is already paid",
  "PAYMENT_REMINDER_IN_PROGRESS": "A payment reminder is currently being sent. Please try again in a moment.",
  "PRODUCT_ALREADY_EXISTS": "The product already exists",
  "PRODUCT_NOT_FOUND": "The product was not found",
  "PRODUCT_INVALID_INPUT": "The product input is invalid",
  "PRODUCT_CREATION_FAILED": "The product creation failed",
  "PRODUCT_UPDATE_FAILED": "The product update failed",
  "PRODUCT_DELETION_FAILED": "The product deletion failed",
  "PRODUCT_UNAUTHORISED": "The user is not authorized to create the product",
  "login_with_email": "Login with email",
  "login_with_phone": "Login with phone",
  "get_mobile_app": "Get the mobile app if you are a coach, player, or parent.",
  "download_on_app_store": "Download on the App Store",
  "get_it_on_google_play": "Get it on Google Play",
  "mobile_not_registered_use_email": "SMS sign-in is unavailable for this number. Continue with email.",
  "email_placeholder": "Email address",
  "send_magic_link": "Send magic link",
  "check_email": "Enter your email and we will send you a secure sign-in link.",
  "email_link_sent": "Magic link sent. Please check your email.",
  "invalid_email": "Please enter a valid email address.",
  "signing_in": "Signing in",
  "login_session_expired": "Your login session expired. Please request a new magic link from this browser.",
  "invalid_or_expired_login_link": "This login link is invalid or expired. Please request a new magic link.",
  "add_email": "Add your email",
  "add_email_body": "SMS login will be retired soon. Add your email now so you can keep signing in without interruption.",
  "save_email": "Save email",
  "remind_me_later": "Remind me later",
  "email_saved_successfully": "Email saved successfully.",
  "email_login_remembered_helper": "Email login stays remembered so your magic link can open securely.",
  "enter_valid_email_or_mobile": "Please enter a valid email or mobile number.",
  "contact": "Contact",
  "date_of_birth": "Date of birth",
  "male": "Male",
  "female": "Female",
  "medical_info": "Medical info",
  "no_allergies_or_conditions": "No allergies or conditions",
  "add_allergy_or_condition": "Add allergy or condition",
  "allergy_or_condition_required": "Add allergy or condition is required",
  "address": "Address",
  "street": "Street",
  "city": "City",
  "state": "State",
  "postal_code": "Postal code",
  "emergency_contact": "Emergency contact",
  "emergency_contact_name": "Emergency contact name",
  "emergency_contact_relationship": "Emergency contact relationship",
  "emergency_contact_phone": "Emergency contact phone",
  "emergency_contact_email": "Emergency contact email",
  "invalid_emergency_contact_email": "Enter a valid emergency contact email",
  "gdpr_document": "GDPR/privacy document",
  "upload_gdpr_document": "Upload GDPR document",
  "replace_gdpr_document": "Replace GDPR document",
  "view_gdpr_document": "View GDPR document",
  "gdpr_document_uploaded": "GDPR document uploaded successfully",
  "gdpr_document_save_pending": "Not saved yet. Select Save to publish this document.",
  "gdpr_document_upload_failed": "Failed to upload GDPR document",
  "GDPR_DOCUMENT_CHANGED": "The GDPR document changed. Reload and review the current document before trying again.",
  "GDPR_UPLOAD_EXPIRED": "This upload expired or was cancelled. Please upload the document again.",
  "GDPR_UPLOAD_NOT_VERIFIED": "The uploaded document could not be verified. Your current GDPR policy has been preserved. Please try again.",
  "no_gdpr_document": "No GDPR document uploaded",
  "gdpr_policy": "GDPR/privacy policy",
  "gdpr_policy_subtitle": "Consent status and academy privacy policy.",
  "accept_gdpr_policy": "I accept the academy privacy/GDPR policy",
  "gdpr_acceptance_required": "You must accept the academy privacy/GDPR policy before continuing.",
  "gdpr_consent_missing": "GDPR missing",
  "gdpr_consent_accepted": "GDPR accepted",
  "gdpr_consent_stale": "GDPR stale",
  "gdpr_consent_not_required": "GDPR not required",
  "gdpr_accepted_at": "Accepted at",
  "profile_identity_documents": "Identity and documents",
  "profile_identity_documents_subtitle": "Identity details, Athlete ID, and Medical Clearance.",
  "medical_info_subtitle": "Allergies, conditions, and related notes.",
  "address_subtitle": "Player mailing address.",
  "contacts_subtitle": "Linked user and parent accounts.",
  "profile_photo": "Profile photo",
  "clothing_size": "Clothing size",
  "ssn_amka": "SSN / AMKA",
  "athlete_id": "Athlete ID",
  "athlete_id_number": "ID",
  "athlete_id_expiration_date": "Athlete ID expiration date",
  "athlete_id_document": "Athlete ID document",
  "medical_clearance": "Medical Clearance",
  "medical_clearance_start_date": "Medical Clearance start date",
  "medical_clearance_expiration_date": "Medical Clearance expiration date",
  "medical_clearance_document": "Medical Clearance document",
  "start_date": "Start date",
  "expiration_date": "Expiration date",
  "add_medical_clearance": "Add Medical Clearance",
  "remove_medical_clearance": "Remove Medical Clearance",
  "remove_medical_clearance_document_hint": "Remove the attached Medical Clearance document first to clear its details.",
  "clear_athlete_id": "Clear Athlete ID",
  "clear_athlete_id_document_hint": "Remove the attached Athlete ID document first to clear its details.",
  "delete_player": "Delete player",
  "delete_player_warning": "This permanently deletes the player and cannot be undone.",
  "delete_player_related_data_warning": "All of this player's payments, including paid payments, orders, notes, form assignments and participation in their teams' activities will be permanently deleted. This action cannot be undone.",
  "upload_document": "Upload document",
  "view_document": "View document",
  "delete_document": "Delete document",
  "confirm_delete_document": "Delete this document?",
  "document_deleted": "Document deleted",
  "document_delete_failed": "Document deletion failed",
  "document_selected": "Document selected",
  "profile_document_invalid_date": "Enter a valid date in YYYY-MM-DD format",
  "medical_clearance_reversed_dates": "Start date must not be after expiration date",
  "profile_document_empty": "The document must not be empty",
  "profile_document_tooLarge": "The document must be 15 MiB or smaller",
  "profile_document_unsupported": "Use a PDF document or a PNG, JPG/JPEG, GIF, SVG, WebP, or HEIC image",
  "BILLING_CLUB_WRITE_RESTRICTED": "This change requires full academy access. Review the subscription or contact your academy’s billing administrator.",
  "profile_document_invalid_request": "The document request is invalid. Check the file and required document details, then try again.",
  "profile_document_authentication_required": "Your session expired. Sign in again to change the document.",
  "profile_document_not_authorized": "You are not authorized to change this Profile document.",
  "profile_document_conflict": "The document changed or the upload is no longer current. Refresh and try again.",
  "profile_document_service_unavailable": "The document could not be changed because the storage service is temporarily unavailable. Try again.",
  "profile_document_timeout": "The document request timed out. Refresh to check its current state before trying again.",
  "profile_document_save_failed": "Changes to the Profile documents could not be completed. Refresh to check their current state before trying again.",
  "profile_management_load_failed": "Profile management data could not be loaded.",
  "profile_photo_empty": "Select a non-empty Profile photo.",
  "profile_photo_upload_requirements": "JPEG, PNG, or WebP (maximum 5 MiB)",
  "profile_photo_unsupported": "Use a JPEG, PNG, or WebP Profile photo.",
  "profile_photo_invalid_request": "The Profile photo request was invalid.",
  "profile_photo_authentication_required": "Your session expired. Sign in again to change the Profile photo.",
  "profile_photo_not_authorized": "You are not authorized to update this Profile photo.",
  "profile_photo_not_found": "The Profile could not be found.",
  "profile_photo_conflict": "The Profile photo changed during the upload. Refresh and try again.",
  "profile_photo_too_large": "The Profile photo must be 5 MiB or smaller.",
  "profile_photo_invalid_image": "The Profile photo could not be decoded. Use a valid JPEG, PNG, or WebP image.",
  "profile_photo_processing_failed": "The Profile photo processing service is temporarily unavailable.",
  "profile_photo_processing_timeout": "Profile photo processing timed out. Try again.",
  "profile_photo_upload_failed": "The Profile photo change could not be completed. Refresh to check its current state before trying again.",
  "login_mobile": "Login mobile",
  "add_login_mobile": "Add login mobile",
  "contact_phone": "Contact phone",
  "add_contact_phone": "Add contact phone",
  "edit_contact_phone": "Edit contact phone",
  "contact_phone_helper": "Separate multiple contact numbers with commas or new lines. Clear the field to remove all contact numbers.",
  "contact_phone_save_failed": "The contact phone could not be saved. Please try again.",
  "user_photo": "Account photo",
  "add_user_photo": "Add account photo",
  "change_user_photo": "Change account photo",
  "edit_user_photo": "Edit account photo",
  "remove_user_photo": "Remove photo",
  "retry_user_photo_refresh": "Retry refresh",
  "user_photo_upload_requirements": "JPEG, PNG, or WebP (maximum 5 MiB)",
  "user_photo_empty": "Select a non-empty account photo.",
  "user_photo_unsupported": "Use a JPEG, PNG, or WebP account photo.",
  "user_photo_invalid_request": "The account photo request was invalid.",
  "user_photo_authentication_required": "Your session expired. Sign in again to change your account photo.",
  "user_photo_not_authorized": "You are not authorized to change this account photo.",
  "user_photo_not_found": "Your user account could not be found.",
  "user_photo_conflict": "The account photo changed during the upload. Refresh and try again.",
  "user_photo_too_large": "The account photo must be 5 MiB or smaller.",
  "user_photo_invalid_image": "The account photo could not be decoded. Use a valid JPEG, PNG, or WebP image.",
  "user_photo_processing_failed": "The account photo processing service is temporarily unavailable.",
  "user_photo_processing_timeout": "Account photo processing timed out. Try again.",
  "user_photo_upload_failed": "The account photo could not be uploaded. Try again.",
  "user_photo_remove_failed": "The account photo could not be removed. Try again.",
  "user_photo_refresh_failed": "The photo changed, but your account could not be refreshed. Retry the refresh without uploading again.",
  "user_photo_impersonation_forbidden": "Account-photo changes are unavailable while impersonating.",
  "account_settings": "Account settings",
  "club_settings": "Academy Settings",
  "account_settings_subtitle": "Manage your personal sign-in and contact information.",
  "account_settings_impersonation_notice": "Account settings cannot be changed while impersonating a user.",
  "account_menu": "Account menu",
  "open_account_menu": "Open account menu",
  "appearance": "Appearance",
  "dark_mode": "Dark mode",
  "sign_in_and_contact": "Sign-in and contact",
  "login_email": "Login email",
  "change_email": "Change email",
  "add_email_title": "Add an email",
  "current_email": "Current email",
  "new_email": "New email",
  "email_change_verification_notice": "Your email will not change until you open and complete the verification link.",
  "email_change_verification_sent": "Verification link sent. Check your email to finish changing it.",
  "email_add_verification_sent": "Verification link sent. Check your email to finish adding it.",
  "email_change_impersonation_forbidden": "Email changes are unavailable while impersonating a user.",
  "email_change_already_in_use": "That email is already in use by another account.",
  "email_change_auth_required": "Your session has changed. Sign in again and retry.",
  "email_change_send_failed": "We could not send the verification link. Please try again.",
  "send_verification_link": "Send verification link",
  "change_mobile_number": "Change mobile number",
  "add_mobile_number": "Add a mobile number",
  "current_mobile": "Current mobile",
  "mobile_number": "Mobile number",
  "mobile_international_format_helper": "Use international format, for example +306900000000",
  "sms_verification_code": "SMS verification code",
  "send_sms_code": "Send SMS code",
  "verify_code": "Verify code",
  "send_new_code": "Send a new code",
  "retry_synchronization": "Retry synchronization",
  "email_change_sync_retry_notice": "Your email was verified. Retry to finish updating this session. No new code is needed.",
  "mobile_change_verified": "Your mobile number was verified and updated.",
  "mobile_change_impersonation_forbidden": "Mobile-number changes are unavailable while impersonating a user.",
  "mobile_change_sync_retry_notice": "SMS verification succeeded, but synchronization must be retried. No new SMS is required.",
  "mobile_change_invalid": "Enter a valid mobile number in international format.",
  "mobile_change_invalid_code": "The SMS verification code is invalid.",
  "mobile_change_code_expired": "The SMS verification session expired. Request a new code.",
  "mobile_change_too_many_attempts": "Too many attempts. Please wait before trying again.",
  "mobile_change_already_in_use": "That mobile number is already in use by another account.",
  "mobile_change_recent_login_required": "For security, sign in again before changing your mobile number.",
  "mobile_change_account_changed": "Your signed-in account changed. Sign in again and restart.",
  "mobile_change_sync_pending": "Your number was verified, but account synchronization is still pending. Retry synchronization.",
  "mobile_change_failed": "The mobile-number change could not be completed. Please try again.",
  "team_drawer_description": "Manage the team's details, cover image, and access.",
  "team_details_title": "Team details",
  "team_details_description": "Set the team's name and age group.",
  "team_cover_title": "Cover image",
  "team_cover_description": "Upload the cover shown on the mobile team page and team cards.",
  "team_access_title": "Team access",
  "team_access_description": "Control access and generate a new team code.",
  "files_drawer_description": "Choose who can access the files and upload new documents.",
  "file_access_title": "File access",
  "file_access_description": "Select the teams and players who can access these files.",
  "file_upload_title": "Files to upload",
  "file_upload_description": "Add the files you want to share.",
  "notes_drawer_description": "Add or update the notes for this player.",
  "order_summary_description": "Review the order details and payment history.",
  "register_user_description": "Add a user and assign their academy or team access.",
  "user_identity_title": "User details",
  "user_identity_description": "Enter the user's name and contact information.",
  "user_access_title": "Role and access",
  "user_access_description": "Choose the user's role, academy, and team.",
  "add_club_admin_description": "Find an existing user and add them as an academy administrator.",
  "find_user_title": "Find user",
  "find_user_description": "Search by email address or mobile number.",
  "edit_club_description": "Update the academy's details, branding, documents, and administrators.",
  "create_club_description": "Add the academy's details and branding.",
  "club_details_title": "Academy details",
  "club_details_description": "Set the academy's name, abbreviation, founding year, country, and sport.",
  "club_branding_title": "Academy branding",
  "club_branding_description": "Choose the academy color and upload its logo.",
  "gdpr_document_description": "Download the current document, or select a new one and choose Save to publish it.",
  "club_admins_description": "View the administrators of this academy and their contact details.",
  "no_club_admins": "No academy administrators found.",
  "club_admins_load_failed": "Academy administrators could not be loaded. Please try again.",
  "assignment_drawer_description": "Review the assignment details and submitted answers.",
  "assignment_details_title": "Assignment details",
  "assignment_details_description": "Review the form information and due date.",
  "assignment_responses_title": "Submitted answers",
  "assignment_responses_description": "Review the player's responses to each question.",
  "not_added": "Not added",
  "super_admin": "Super Admin",
  "staff_page_subtitle": "Add coaches and admins to your academy and assign their teams and roles.",
  "staff_page_summary": "{{count}} staff members in this academy",
  "staff_search": "Search name, email or mobile",
  "staff_all_roles": "All roles",
  "staff_admin": "Admin",
  "staff_add_team": "Add team…",
  "staff_activity": "Activity",
  "staff_recently_active": "Recently active",
  "staff_last_active": "Last active",
  "staff_never_connected": "Never connected",
  "staff_activity_unknown": "No activity recorded",
  "staff_activity_hint": "Activity was recorded within the last 5 minutes.",
  "staff_no_results": "No staff match these filters.",
  "staff_load_failed": "Staff could not be loaded. Please try again.",
  "staff_no_access": "You must administer the selected academy to manage its staff.",
  "staff_remove": "Remove staff",
  "staff_remove_confirmation": "Remove all staff access for {{name}} in {{club}}?",
  "staff_remove_scope": "This removes their academy-admin, team-admin and coach assignments in this academy. Their account, player or parent access, and access to other academies are preserved.",
  "staff_remove_failed": "Staff access could not be removed. Please try again.",
  "staff_removed": "Staff access removed.",
  "staff_join_instructions": "Staff can sign in with this email or mobile. Their assigned access will be available automatically.",
  "STAFF_INVALID_INPUT": "Check the staff details, role and selected teams, then try again.",
  "STAFF_CANNOT_REMOVE_SELF": "Another academy administrator must remove your staff access.",
  "STAFF_CANNOT_REMOVE_LAST_CLUB_ADMIN": "Add another academy administrator before removing the last one.",
  "AUTH_IDENTITY_CONFLICT": "These contact details do not match a single existing account. Use the account's current email or mobile.",
  "PAYER_OWNER_MUST_RELINQUISH": "Assign a new subscription owner before removing this administrator.",
  "PAYER_CLUB_ADMIN_HANDOFF_REQUIRED": "Assign another administrator to manage the subscription before removing this administrator.",
  "PAYER_ACCESS_STATE_NOT_PERSISTED": "We couldn’t confirm subscription permissions. Please try again.",
  "profile_no_linked_account": "No linked account",
  "profile_activity_load_failed": "Account activity could not be loaded. Please try again.",
  "deployment_update_title": "New version available",
  "deployment_update_description": "Save your changes, then refresh to update Manager.",
  "deployment_update_refresh": "Refresh",
  "billing_trial_reminder_days": "Your free trial ends in {days} days",
  "billing_trial_reminder_last_day": "Your free trial ends within 24 hours",
  "billing_trial_reminder_add_card": "Add a card to keep using all features after the trial. Any amount due will be charged automatically when it ends unless you cancel beforehand.",
  "billing_trial_reminder_contact_admin": "Ask your academy’s billing administrator to add a card before the trial ends to keep full access.",
  "billing_add_card": "Add card",
  "billing_state_full_without_subscription": "Your academy currently has full access without a subscription. Start a subscription to keep using all features after this free-access period.",
  "billing_state_trialing_without_card": "Your free trial is active with full access. No card has been added yet. A card is needed before the trial ends to continue using all features.",
  "billing_state_trialing_with_card": "Your free trial is active with full access, and a payment method is saved. Any amount due will be charged automatically when the trial ends unless you cancel beforehand.",
  "billing_state_past_due_inactive": "Full access has stopped because a subscription payment is still pending. You can still browse Manager and view academy information, but changes to academy data are restricted.",
  "billing_state_trial_ended": "Your free trial has ended. You can still browse Manager and view academy information, but changes to academy data are restricted.",
  "billing_notice_view_only": "Your academy has view-only access",
  "billing_notice_restore_access": "Restore full access",
  "billing_notice_payment_attention": "A payment needs attention",
  "billing_notice_cancel_scheduled": "Your subscription is ending",
  "billing_notice_subscription": "Set up your academy’s subscription",
  "billing_review_subscription": "View subscription",
  "billing_contact_administrator": "Contact your academy’s billing administrator for help.",
  "billing_recovery_start_trial": "Start your available 30-day free trial to restore full access. No card is needed to start.",
  "billing_recovery_start_subscription": "Start a subscription to restore full access. Any amount due, including discounts, is shown before confirmation.",
  "billing_recovery_manage_subscription": "Open Manage subscription to review the next step for restoring full access.",
  "billing_recovery_contact_support": "Contact PlayerDex support for help restoring full access.",
  "billing_state_full_needs_review": "Your academy currently has full access. Review your subscription to keep using all features.",
  "billing_state_needs_review": "Review your subscription details or contact PlayerDex support for help.",
  "registration_billing_setup_failed": "Your academy has been created, but trial setup is not complete. Please try again to finish setup.",
  "billing_trial_without_details": "Start your 30-day free trial. No card, VAT number, billing address or shipping address is needed.",
  "billing_details_on_stripe": "Add your VAT number, business name, billing address and email on Stripe. Return to Manager to continue to your subscription and add a card.",
  "billing_start_free_trial": "Start free trial",
  "billing_complete_details": "Complete billing details",
  "billing_continue_after_details": "I saved my details — continue",
  "billing_setup_error": "We could not complete this step. Please try again.",
  "billing_details_incomplete": "Complete your VAT number, business name, billing address and email on Stripe, then return and continue.",
  "billing_trial_not_available": "A new free trial is not available for this academy. Refresh this page to see your subscription options.",
  "billing_trial_ending_soon": "Your trial ends within 31 minutes. Please return after it ends to complete your subscription.",
  "billing_notice_trial_active": "Your free trial is active",
  "billing_local_trial_active": "Your free trial is active with full access. Add a payment method to keep full access after it ends.",
  "billing_trial_reminder_complete_details": "Add a payment method to keep full access after your trial. You will not be charged before the trial ends.",
  "billing_add_payment_method": "Add payment method",
  "billing_opening_stripe": "Opening your billing options…",
  "billing_back_to_manager": "Back to Manager",
  "billing_return_other_club": "Switch back to the academy whose billing you opened, then try again.",
  "billing_resolve_payment": "Resolve payment",
  "billing_continue_to_checkout": "Continue to payment",
  "billing_paused_choose_plan": "Reactivate your subscription",
  "billing_paused_plan_explanation": "Choose a plan, then continue to Stripe to add your card and billing details and confirm reactivation. You can manage your plan in Stripe after reactivation.",
  "billing_paused_plan_label": "Subscription plan",
  "billing_paused_monthly": "Monthly",
  "billing_paused_yearly": "Yearly",
  "billing_paused_continue_stripe": "Continue to Stripe",
  "billing_paused_state_changed": "Your subscription has changed. Open Billing again to see the available options.",
  "billing_paused_plan_locked": "A plan has already been selected. Open Billing again to continue with that plan.",
  "billing_paused_setup_in_progress": "Subscription setup is already in progress. Please try again.",
  "billing_paused_details_required": "Your billing name, email, address and VAT number must be complete before reactivation. Contact support if you need help updating them.",
  "billing_paused_contact_support": "We could not safely continue subscription setup. Please contact support.",
  "website": "Website",
  "preview_website": "Preview Website",
  "preview_website_no_slug": "Website preview is not set up for this academy yet.",
  "website_page_title": "Website",
  "website_page_subtitle": "Manage and preview your academy's public website.",
  "website_page_no_slug_notice": "Your academy website address is not set up yet. Contact PlayerDex to get one assigned.",
  "website_page_tab_general": "General",
  "website_page_tab_appearance": "Appearance",
  "website_page_tab_sections": "Sections",
  "website_page_tab_teams": "Teams",
  "website_page_tab_privacy": "Privacy",
  "website_page_tab_branding": "Branding",
  "website_page_general_section": "General",
  "website_page_slug": "Website address",
  "website_page_address_placeholder": "your-academy-name",
  "website_page_address_checking": "Checking availability…",
  "website_page_address_available": "Available",
  "website_page_address_invalid_format": "Use 3-40 lowercase letters, numbers, or hyphens (not at the start or end).",
  "website_page_address_reserved": "This address is reserved and can't be used.",
  "website_page_address_taken": "This address is already taken.",
  "website_page_address_check_error": "Couldn't check availability. Try again.",
  "website_page_address_future_notice": "Your academy's future website address:",
  "website_page_custom_domain_title": "Custom domain",
  "website_page_custom_domain_desc": "Use your own domain (like youracademy.com) instead of the free playerdex.app address.",
  "website_page_custom_domain_connect_button": "Connect a domain",
  "website_page_custom_domain_upgrade_notice": "Custom domains are available on paid plans.",
  "website_page_custom_domain_upgrade_button": "Upgrade",
  "website_page_custom_domain_choose_connect": "Connect it myself",
  "website_page_custom_domain_choose_assisted": "Ask PlayerDex to set it up",
  "website_page_custom_domain_hostname_placeholder": "youracademy.com",
  "website_page_custom_domain_hostname_invalid": "Enter a valid domain, e.g. youracademy.com.",
  "website_page_custom_domain_wizard_back": "Back",
  "website_page_custom_domain_wizard_continue": "Continue",
  "website_page_custom_domain_wizard_disclaimer": "This isn't fully automatic yet — our team finishes the setup by hand once you continue.",
  "website_page_custom_domain_wizard_instructions_title": "Add this DNS record at your domain's registrar:",
  "website_page_custom_domain_wizard_record_type": "Type",
  "website_page_custom_domain_wizard_record_host": "Host",
  "website_page_custom_domain_wizard_record_value": "Value",
  "website_page_custom_domain_wizard_record_value_pending": "Confirmed after you continue",
  "website_page_custom_domain_wizard_apex_note": "If your domain has no \"www\", it should redirect to the www version.",
  "website_page_custom_domain_wizard_confirm": "I've added this record",
  "website_page_custom_domain_assisted_submit": "Send request",
  "website_page_custom_domain_status_requested": "Requested",
  "website_page_custom_domain_status_pending_dns": "Waiting on DNS",
  "website_page_custom_domain_status_verifying": "Verifying",
  "website_page_custom_domain_status_active": "Active",
  "website_page_custom_domain_status_failed": "Failed",
  "website_page_custom_domain_status_expired": "Expired",
  "website_page_custom_domain_check_status": "Check status",
  "website_page_custom_domain_cancel": "Cancel request",
  "website_page_custom_domain_added_success": "Request sent.",
  "website_page_custom_domain_error": "Something went wrong. Try again.",
  "website_page_appearance_section": "Appearance",
  "website_page_appearance_color_label": "Accent color",
  "website_page_appearance_color_desc": "Choose the color used across your academy's public website.",
  "website_page_sections_section": "Page sections",
  "website_page_sections_section_desc": "Choose what visitors can see on your academy's public website.",
  "website_page_toggle_staff_label": "Coaches & staff",
  "website_page_toggle_staff_desc": "Show your coaching staff on the Roster tab.",
  "website_page_toggle_roster_label": "Player roster",
  "website_page_toggle_roster_desc": "Show your team's players on the Roster tab.",
  "website_page_toggle_events_label": "Fixtures & results",
  "website_page_toggle_events_desc": "Show upcoming fixtures and match results on the Events tab.",
  "website_page_toggle_photos_label": "Photo gallery",
  "website_page_toggle_photos_desc": "Show match and event photos on the Photos tab.",
  "website_page_toggle_attendance_label": "Attendance rankings",
  "website_page_toggle_attendance_desc": "Show the attendance leaderboard on the Attendance tab.",
  "website_page_toggle_posts_label": "News & updates",
  "website_page_toggle_posts_desc": "Show your academy's news posts on the News tab.",
  "website_page_settings_load_error": "Couldn't load the website settings. Please refresh the page.",
  "website_page_settings_saved": "Website settings saved.",
  "website_page_settings_save_error": "Could not save website settings. Please try again.",
  "website_page_live_toggle_label": "Website is live",
  "website_page_live_toggle_desc_on": "Visitors can see your public website.",
  "website_page_live_toggle_desc_off": "Visitors see a \"coming soon\" page instead of your site.",
  "website_page_live_off_alert": "Your public website is turned off. Visitors will see a \"coming soon\" page until you turn it back on.",
  "website_page_privacy_section": "Privacy",
  "website_page_privacy_section_desc": "Control how player and coach names and photos appear on your public website.",
  "website_page_name_display_label": "Name display",
  "website_page_name_display_full": "Full name",
  "website_page_name_display_initial": "First name + last initial",
  "website_page_name_display_first": "First name only",
  "website_page_toggle_player_photos_label": "Player & coach photos",
  "website_page_toggle_player_photos_desc": "Show real photos on the public website. Turn off to show initials only.",
  "website_page_branding_section": "Content & branding",
  "website_page_branding_section_desc": "Add extra details to your academy's public website.",
  "website_page_about_label": "About your academy",
  "website_page_about_placeholder": "Tell visitors a bit about your academy...",
  "website_page_toggle_contact_label": "Contact info",
  "website_page_toggle_contact_desc": "Show your academy's phone, email and website on the public site.",
  "website_page_toggle_contact_phone_label": "Phone",
  "website_page_toggle_contact_email_label": "Email",
  "website_page_toggle_contact_website_label": "Website",
  "website_page_toggle_contact_address_label": "Address",
  "website_page_toggle_contact_detail_desc": "Shown on the public site while contact info is on.",
  "website_page_social_https_error": "Social links must start with https://",
  "website_page_social_label": "Social links",
  "website_page_social_instagram": "Instagram",
  "website_page_social_facebook": "Facebook",
  "website_page_social_x": "X (Twitter)",
  "website_page_social_youtube": "YouTube",
  "website_page_teams_search_placeholder": "Search teams",
  "website_page_teams_filter_all": "All teams",
  "website_page_teams_filter_on": "On website",
  "website_page_teams_filter_hidden": "Hidden",
  "website_page_teams_age_group": "Age group",
  "website_page_teams_summary": "teams on website",
  "website_page_teams_selected": "selected",
  "website_page_teams_show": "Show on website",
  "website_page_teams_hide": "Hide from website",
  "website_page_teams_clear_selection": "Clear selection",
  "website_page_teams_col_team": "Team",
  "website_page_teams_col_age_group": "Age group",
  "website_page_teams_col_website": "Website",
  "website_page_teams_no_matches": "No teams match your search or filters.",
  "website_page_teams_select_all": "Select all teams shown",
  "website_page_teams_select_team": "Select team",
  "website_page_teams_section_desc": "Choose which of your teams have a page on your academy's public website.",
  "website_page_teams_empty": "Your academy has no teams yet.",
  "website_page_teams_load_error": "Could not load your teams. Please try again.",
  "activity_section_details": "Activity details",
  "activity_section_timing": "Date & time",
  "activity_section_location": "Location",
  "activity_section_attendance": "Attendance settings",
  "activity_section_notes": "Notes & attachments",
  "activity_selected_count": "{selected} of {total} selected",
  "activity_search_players": "Search players",
  "activity_select_all": "Select all",
  "activity_clear_selection": "Clear",
  "activity_show_selected": "Show selected",
  "activity_no_search_results": "No players match your search.",
  "activity_no_participants": "No players in the selected teams.",
  "activity_ends": "Ends",
  "activity_arrive": "Arrive",
  "activity_location_selected": "Location selected",
  "activity_location_hint": "Search for an address or choose a point on the map.",
  "activity_show_map": "Show map",
  "activity_hide_map": "Hide map",
  "activity_details_load_error": "Activity details could not be loaded.",
  "activity_details_retry": "Try again",
  "activity_details_cancelled": "This activity is cancelled.",
  "activity_details_attendance": "Attendance",
  "activity_details_rsvp": "RSVP responses",
  "activity_details_filter": "Filter participants by status",
  "activity_details_show_all": "Show all participants",
  "activity_details_remind": "Remind non-responders",
  "activity_details_loading": "Loading…",
  "activity_details_no_results": "No participants match your search or filter.",
  "activity_details_no_participants": "No participants yet.",
  "activity_search_participants": "Search participants",
  "activity_details_going_plural": "Going",
  "activity_details_not_going_plural": "Not Going",
  "activity_details_unanswered_plural": "Not Answered",
  "activity_details_attended_singular": "Attended",
  "activity_details_not_attended_singular": "Not Attended",
  "billing_tax_identity_title": "Tax registration details",
  "billing_tax_identity_explanation": "Enter the details of the organisation named on the invoice. You will then continue to Stripe for the remaining billing details.",
  "billing_tax_country": "Billing country",
  "billing_tax_country_gr": "Greece",
  "billing_tax_country_cy": "Cyprus",
  "billing_tax_afm": "Greek tax number (AFM)",
  "billing_tax_afm_hint": "9 digits.",
  "billing_tax_tic": "Tax Identification Code (TIC)",
  "billing_tax_tic_hint": "8 digits and one Latin letter. Required even without VAT registration.",
  "billing_tax_vat_optional": "VAT number (optional)",
  "billing_tax_vat_hint": "Enter only if registered for VAT in Cyprus. A TIC does not establish VAT registration.",
  "billing_tax_identity_invalid": "Check the format of the tax number and optional VAT number.",
  "billing_tax_identity_locked": "A Checkout is already in progress. Complete it or contact support.",
  "billing_tax_identity_save_error": "The tax details could not be saved. Please try again.",
  "billing_tax_saving": "Saving…",
  "billing_tax_continue": "Continue to Stripe",
  "combobox_clear": "Clear",
  "combobox_open": "Show options",
  "players_import_button": "Import",
  "players_import_title": "Import players",
  "players_import_description": "Add many players at once from a file or by typing them in.",
  "players_import_mode_auto_title": "Upload a file",
  "players_import_mode_auto_description": "Import from an Excel (.xlsx, .xls), .ods or .csv file.",
  "players_import_mode_manual_title": "Type them in",
  "players_import_mode_manual_description": "Fill in a table with one player per row.",
  "players_import_step_file": "File",
  "players_import_step_columns": "Columns",
  "players_import_step_players": "Players",
  "players_import_step_preview": "Preview",
  "players_import_step_result": "Result",
  "players_import_title_file": "Import your players file",
  "players_import_title_columns": "Match your file's columns",
  "players_import_title_manual": "Add players",
  "players_import_title_preview": "Check the players",
  "players_import_title_result": "Import result",
  "players_import_required_info": "Required information:",
  "players_import_optional_info": "Optional information:",
  "players_import_drop_title": "Drag and drop your file here",
  "players_import_drop_or": "or",
  "players_import_browse": "browse your files",
  "players_import_drop_hint": "Upload your .xlsx, .xls, .ods or .csv file (max 5 MB)",
  "players_import_remove_file": "Remove file",
  "players_import_file_too_large": "The file is larger than 5 MB.",
  "players_import_file_invalid_type": "Upload an .xlsx, .xls, .ods or .csv file.",
  "players_import_file_empty": "The file has no rows.",
  "players_import_file_unreadable": "We couldn't read this file. Check that it is a valid spreadsheet.",
  "players_import_template_title": "Need a place to start?",
  "players_import_template_description": "Download our template with the columns we read.",
  "players_import_template_download": "Download",
  "players_import_columns_intro": "Pick which column in your file holds each piece of player information.",
  "players_import_skip_header": "Skip the first line of the file (headers)",
  "players_import_first_line": "First line detected:",
  "players_import_playerdex_field": "Playerdex field",
  "players_import_file_column": "File column",
  "players_import_column": "Column",
  "players_import_select_column": "Select a column",
  "players_import_no_column": "Don't import",
  "players_import_required": "Required",
  "players_import_optional": "Optional",
  "players_import_field_last_name": "Last name",
  "players_import_field_last_name_example": "e.g. Papadopoulos, Smith",
  "players_import_field_first_name": "First name",
  "players_import_field_first_name_example": "e.g. Nikos, Emily",
  "players_import_field_email": "Email address",
  "players_import_field_email_example": "e.g. parent@email.com",
  "players_import_field_phone": "Phone",
  "players_import_field_phone_example": "e.g. 6912345678",
  "players_import_field_birth_date": "Birth date",
  "players_import_field_birth_date_example": "e.g. 07/12/2014 or 2014",
  "players_import_field_address": "Postal address",
  "players_import_field_address_example": "e.g. 12 Ermou St, Athens",
  "players_import_field_team": "Team",
  "players_import_field_team_example": "Must match a team name, e.g. U12",
  "players_import_field_gender": "Gender",
  "players_import_field_gender_example": "e.g. M / F",
  "players_import_field_ssn": "SSN / AMKA",
  "players_import_field_ssn_example": "e.g. 07121401234",
  "players_import_field_clothing_size": "Clothing size",
  "players_import_field_clothing_size_example": "e.g. 12 or M",
  "players_import_manual_intro": "Add one player per row. Empty rows are ignored.",
  "players_import_add_row": "Add row",
  "players_import_remove_row": "Remove row",
  "players_import_preview_summary": "{{ready}} ready to import · {{invalid}} need attention",
  "players_import_preview_invalid_hint": "You can edit any cell here. Rows that still have errors will be skipped.",
  "players_import_assign_missing_team": "{{count}} without team:",
  "players_import_assign_missing_team_label": "Assign a team to all players without one",
  "players_import_select_team": "Select a team",
  "players_import_column_player": "Player",
  "players_import_column_status": "Status",
  "players_import_status_ready": "Ready",
  "players_import_error_name": "First and last name are required.",
  "players_import_error_email": "The email address is not valid.",
  "players_import_error_birth_date": "The birth date is not valid. Use DD/MM/YYYY.",
  "players_import_error_birth_date_future": "The birth date is in the future.",
  "players_import_error_team_missing": "Pick a team.",
  "players_import_error_team_unknown": "This team doesn't exist in your academy. Pick a team.",
  "players_import_warning_gender": "Gender not recognised. It will be left empty.",
  "players_import_warning_duplicate": "This player appears more than once in the list.",
  "players_import_submit": "Import {{count}} players",
  "players_import_progress": "Importing {{done}} of {{total}} players...",
  "players_import_result_created": "{{count}} players imported.",
  "players_import_result_skipped": "{{count}} rows skipped because of errors.",
  "players_import_result_failed": "{{count}} players could not be imported.",
  "players_import_result_failed_hint": "Download them, fix them and import them again.",
  "players_import_error_column": "Error",
  "players_import_download_failed": "Download failed rows",
  "players_import_continue": "Continue",
  "players_import_back": "Previous step",
  "players_import_done": "Done",
  "players_import_discard_title": "Stop importing?",
  "players_import_discard_description": "The players you added here will not be saved.",
  "players_import_discard_cancel": "Keep going",
  "players_import_discard_confirm": "Discard",
  "players_import_birth_date_placeholder": "DD/MM/YYYY",
  "players_import_error_email_exists": "A player with this email already exists in your academy.",
  "players_import_error_email_duplicate": "This email is already used by an earlier row.",
  "players_import_existing_checking": "Checking which players already exist in your academy...",
  "players_import_existing_failed": "We couldn't check for existing players. Try again to continue.",
  "players_import_existing_found": "{{count}} players already exist in your academy (same email) and will be skipped.",
  "players_import_progress_single": "Importing {{total}} players...",
  "players_import_outcome_unknown_title": "We couldn't confirm the import",
  "players_import_outcome_unknown_description": "Some players may have been created. Check the players list before importing again, so nobody is added twice.",
  "players_import_result_unconfirmed": "{{count}} players could not be confirmed:",
  "EMAIL_ALREADY_EXISTS": "A player with this email already exists in your academy",
  "INVALID_INPUT": "Some of the information is not valid",
  "EVENT_BACKFILL_FAILED": "The player couldn't be added to the team's upcoming activities",
  "BATCH_TOO_LARGE": "Too many players in one import. Import up to 500 at a time.",
  "PROFILE_BATCH_SCOPE_CHANGED": "The teams' activities changed during the import. Try again.",
  "PROFILE_BATCH_FAILED": "The import failed. No players were added. Try again.",
  "PROFILE_BATCH_OUTCOME_UNKNOWN": "We couldn't confirm which players were added",
  "date_picker_open": "Choose date",
  "time_picker_open": "Choose time",
  "date_picker_previous_day": "Previous day",
  "date_picker_next_day": "Next day",
  "date_picker_previous_month": "Previous month",
  "date_picker_next_month": "Next month",
  "date_picker_previous_year": "Previous year",
  "date_picker_next_year": "Next year",
  "date_range_start": "Start date",
  "date_range_end": "End date",
  "phone_country": "Phone country",
  "location_fetch_error": "Could not get this location. Please try again.",
  "location_fetch_failed": "Could not load locations after several tries.",
  "billing_invoice_details_title": "Invoice details",
  "billing_invoice_status_open": "View invoice status",
  "billing_invoice_status_title": "Invoice status",
  "billing_invoice_details_open": "Complete invoice details",
  "billing_invoice_paid_pending": "Your payment was successful. You do not need to pay again.",
  "billing_invoice_details_load_error": "We could not load your invoice details. Please retry or contact your billing administrator.",
  "billing_invoice_details_none": "There are no invoice details awaiting your action. If you just paid, processing may take a moment.",
  "billing_invoice_reference": "Invoice reference",
  "billing_invoice_vat_invalid": "The Cyprus VAT number was not validated. The standard VAT rate applies to the invoice. Your payment remains successful.",
  "billing_invoice_vies_pending": "VAT verification is temporarily unavailable. We will retry automatically; your payment remains successful.",
  "billing_invoice_details_needed": "Complete the tax details below so we can prepare your invoice.",
  "billing_invoice_processing": "No additional tax details are requested here. For help with your invoice or its email delivery, contact support.",
  "billing_invoice_details_explanation": "These details apply to this paid invoice. The country comes from Stripe. We check the tax number format; Cyprus VAT is verified before issuing the invoice.",
  "billing_invoice_details_save": "Save invoice details",
  "billing_invoice_details_busy": "Invoice processing is busy. Please retry shortly.",
  "billing_invoice_details_review": "This invoice can no longer be edited here. Please contact support.",
  "billing_invoice_future_details": "Manage future billing details in Stripe",
  "billing_continue_stripe": "Continue to Stripe",
  "billing_annual_invoice_entry": "Pay by bank transfer",
  "billing_annual_invoice_description": "Annual €500 plan. Stripe issues the first invoice with bank-transfer instructions when your academy is eligible. Bank-transfer renewals are not available yet.",
  "billing_new_subscriptions_disabled": "New subscriptions are not currently available for this academy. You can return to Manager or refresh to check availability.",
  "billing_bank_trial_conversion_unavailable": "Bank transfer is not yet available for this academy's existing trial. Your trial stays unchanged.",
  "billing_card_promotion_codes_stripe": "If available, enter your promotion code in Stripe Checkout.",
  "billing_subscription_choice_description": "Choose how to pay for your subscription. Payment is completed securely on Stripe.",
  "billing_card_subscription_entry": "Pay by card",
  "billing_card_subscription_description": "Choose monthly or annual billing in Stripe. Card payments and renewals are managed by Stripe.",
  "billing_bank_trial_started": "Your 30-day bank-transfer trial has started. No payment is due now. Trial end date:",
  "billing_bank_annual_invoice_pending": "Your first annual bank-transfer invoice is not available yet. Please check again later.",
  "billing_bank_setup_pending": "Your annual bank-transfer setup is still in progress. Select Refresh to continue."
}
